import React, { useEffect, useState, useRef } from "react";
import { db } from "../../firebase.init";
import {
    collection, addDoc, serverTimestamp, getDocs, doc, deleteDoc, setDoc, getDoc, query, where, collectionGroup
} from "firebase/firestore";
import { Form, Button, Spinner, Row, Col, Card, Badge, Nav, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClipboardCheck, faCalendarDay, faHome, faUser, faBuilding, faClock, faDoorClosed, faKey,
    faEnvelope, faPhone, faMailReply, faMailBulk, faList, faCalendar, faTrash, faShieldAlt
} from "@fortawesome/free-solid-svg-icons";
import "./BookInspection.css";
import Select from "react-select";
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase.init';
import * as XLSX from 'xlsx';
import { useUserRole } from '../../hooks/useUserRole';

const BookInspection = () => {

    const [buildingName, setBuildingName] = useState("");
    const [flatNo, setFlatNo] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [firstDate, setFirstDate] = useState("");
    const [secondDate, setSecondDate] = useState("");
    const [keyGivenToManager, setKeyGivenToManager] = useState(true);
    const [keyDetails, setKeyDetails] = useState("");
    const [loading, setLoading] = useState(false);
    const [displayedText, setDisplayedText] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const [availableSlots, setAvailableSlots] = useState({});
    const [buildings, setBuildings] = useState([]);

    const [availableDates, setAvailableDates] = useState([]);
    const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
    const [selectedSecondDate, setSelectedSecondDate] = useState("");
    const [selectedSecondTimeSlot, setSelectedSecondTimeSlot] = useState("");
    const [slotCounts, setSlotCounts] = useState({});
    const [calendarSlots, setCalendarSlots] = useState({});

    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);

    const [bookingType, setBookingType] = useState("tenant");
    const [tenantEmail, setTenantEmail] = useState("");
    const [tenantPhone, setTenantPhone] = useState("");
    const [notAvailable, setNotAvailable] = useState(false);
    const [unavailableDate, setUnavailableDate] = useState("");
    const [unavailableBuildingFilter, setUnavailableBuildingFilter] = useState('all');
    const [unavailableDateFilter, setUnavailableDateFilter] = useState('future');
    const [unavailableError, setUnavailableError] = useState("");
    const [unavailableReason, setUnavailableReason] = useState("");
    const [unavailableDetails, setUnavailableDetails] = useState("");
    const [unavailableResponses, setUnavailableResponses] = useState([]);
    const [unavailableLoading, setUnavailableLoading] = useState(false);
    const [submittedUnavailable, setSubmittedUnavailable] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [bookingToDelete, setBookingToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [resendingIds, setResendingIds] = useState(new Set());

    const [user, loadingAuth] = useAuthState(auth);

    // 

    const [activeTab, setActiveTab] = useState('book');
    const [allBookings, setAllBookings] = useState([]);
    const [bookingsLoading, setBookingsLoading] = useState(false);
    const [buildingFilter, setBuildingFilter] = useState('all');
    const [dateFilter, setDateFilter] = useState('future');

    const userData = useUserRole();

    const fetchAllBookings = async () => {
        setBookingsLoading(true);
        try {
            const bookings = [];

            const bookingsSnapshot = await getDocs(collectionGroup(db, 'bookings'));

            bookingsSnapshot.forEach(bookingDoc => {
                const data = bookingDoc.data();

                const dateId = bookingDoc.ref.parent.parent.id;
                const buildingId = bookingDoc.ref.parent.parent.parent.parent.id;

                bookings.push({
                    id: bookingDoc.id,
                    buildingId: buildingId,
                    buildingName: data.buildingAddress?.split(',')[0]?.trim() || buildingId,
                    date: dateId,
                    createdAt: data.createdAt,
                    ...data
                });
            });

            bookings.sort((a, b) => {
                const dateA = a.date?.split('/').reverse().join('-');
                const dateB = b.date?.split('/').reverse().join('-');
                return dateB?.localeCompare(dateA) || b.createdAt?.toDate?.() - a.createdAt?.toDate?.();
            });

            setAllBookings(bookings);
        } catch (error) {
            console.error('Error fetching bookings:', error);
        } finally {
            setBookingsLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === 'view' && (userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator')) {
            fetchAllBookings();
        }
    }, [activeTab]);

    const fetchUnavailableResponses = async () => {
        setUnavailableLoading(true);
        setUnavailableError("");
        try {
            const snapshot = await getDocs(collectionGroup(db, "unavailableResponses"));
            const responses = snapshot.docs.map(item => ({
                id: item.id,
                buildingId: item.ref.parent.parent?.id,
                ...item.data(),
            }));
            responses.sort((a, b) => (b.submittedAt?.seconds || 0) - (a.submittedAt?.seconds || 0));
            setUnavailableResponses(responses);
        } catch (err) {
            console.error("Error loading unavailable responses:", err);
            setUnavailableError("Unable to load responses. Please try Refresh.");
        } finally {
            setUnavailableLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === 'unavailable' && ['admin', 'manager', 'inspection', 'coordinator'].includes(userData.role)) {
            fetchUnavailableResponses();
        }
    }, [activeTab, userData.role]);

    // Date-only values use YYYY-MM-DD; compare against the site's UK calendar day.
    const todayInLondon = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    const todayKey = ['year', 'month', 'day'].map(type => todayInLondon.find(p => p.type === type).value).join('-');
    const isValidDateKey = value => {
        if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
        const parsed = new Date(`${value}T00:00:00Z`);
        return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
    };
    const unavailableBuildings = [...new Set(unavailableResponses.map(r => r.buildingName).filter(Boolean))].sort();
    const filteredUnavailableResponses = unavailableResponses.filter(response => {
        if (unavailableBuildingFilter !== 'all' && response.buildingName !== unavailableBuildingFilter) return false;
        if (unavailableDateFilter === 'all') return true;
        // Legacy responses without a date belong only in All, never in Upcoming/Past.
        if (!isValidDateKey(response.unavailableDate)) return false;
        return unavailableDateFilter === 'future'
            ? response.unavailableDate >= todayKey
            : response.unavailableDate < todayKey;
    });

    const unavailableReasonLabel = reason => ({ holiday: 'Holiday', work: 'Work commitments', illness: 'Illness / medical', no_access: 'No access', other: 'Other' })[reason] || reason || '—';
    const exportUnavailableToExcel = () => {
        const rows = filteredUnavailableResponses.map(response => ({
            Building: response.buildingName || '', Flat: response.flatNo || '',
            'Unavailable Date': isValidDateKey(response.unavailableDate) ? response.unavailableDate.split('-').reverse().join('/') : 'Not specified',
            Email: response.email || '', Phone: response.phone || '',
            'Submitted By': response.bookingType || '', 'Tenant Email': response.tenantEmail || '',
            'Tenant Phone': response.tenantPhone || '', Reason: unavailableReasonLabel(response.reason),
            Details: response.details || '', Status: 'Not Available',
            'Submitted At': response.submittedAt?.toDate?.().toLocaleString('en-GB') || ''
        }));
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Not Available');
        XLSX.writeFile(workbook, `FireChecked_Unavailability_${todayKey}.xlsx`);
    };

    const getStatusBadge = (booking) => {
        if (booking.firstSlotUid || booking.secondSlotUid) {
            return <Badge bg="success">Confirmed</Badge>;
        }
        return <Badge bg="warning" text="dark">Pending</Badge>;
    };

    // const formatDate = (dateStr) => {
    //     if (!dateStr) return 'N/A';
    //     const [day, month, year] = dateStr.split('/');
    //     return `${day}/${month}/${year}`;
    // };

    // 

    const safeDate = (value) => {
        if (!value) return 'N/A';

        if (value.seconds) {
            return new Date(value.seconds * 1000).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        }

        if (value instanceof Date) {
            return value.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        }

        if (typeof value.toDate === 'function') {
            return value.toDate().toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        }
        if (typeof value === 'string' && value.includes('/')) {
            return value;
        }
        return String(value);
    };

    const safeString = (value) => {
        if (!value) return 'N/A';
        if (typeof value === 'string') return value;
        if (value.seconds) return new Date(value.seconds * 1000).toLocaleString('en-GB');
        return String(value);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';

        if (dateStr.seconds) {
            return new Date(dateStr.seconds * 1000).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        }
        if (typeof dateStr === 'string' && dateStr.includes('/')) {
            const [day, month, year] = dateStr.split('/');
            return `${day}/${month}/${year}`;
        }
        return String(dateStr);
    };

    const uniqueBuildings = [...new Set(allBookings.map(b => {
        const s = (val) => {
            if (val === null || val === undefined) return '';
            if (typeof val === 'string') return val;
            if (val.seconds) return new Date(val.seconds * 1000).toLocaleString('en-GB');
            return String(val);
        };
        return s(b.buildingName);
    }))].filter(Boolean).sort();

    const filteredBookings = allBookings.filter(b => {
        const s = (val) => {
            if (val === null || val === undefined) return '';
            if (typeof val === 'string') return val;
            if (val.seconds) return new Date(val.seconds * 1000).toLocaleString('en-GB');
            return String(val);
        };

        if (buildingFilter !== 'all' && s(b.buildingName) !== buildingFilter) {
            return false;
        }

        if (dateFilter !== 'all') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            let bookingDate = null;
            const dateStr = s(b.firstDate) || s(b.date);

            try {

                if (dateStr && dateStr.includes('/')) {
                    const [day, month, year] = dateStr.split('/');
                    bookingDate = new Date(Number(year), Number(month) - 1, Number(day));
                    bookingDate.setHours(0, 0, 0, 0);
                }
                else if (dateStr && dateStr.seconds) {
                    bookingDate = new Date(dateStr.seconds * 1000);
                    bookingDate.setHours(0, 0, 0, 0);
                }
            } catch (e) {
                return true;
            }

            if (!bookingDate || isNaN(bookingDate.getTime())) {
                return true;
            }

            if (dateFilter === 'future' && bookingDate < today) {
                return false;
            }
            if (dateFilter === 'past' && bookingDate >= today) {
                return false;
            }
        }

        return true;
    });

    const getSlotBookingCount = (buildingName, date, slotUid) => {
        return allBookings.filter(b => {
            const s = (val) => {
                if (val === null || val === undefined) return '';
                if (typeof val === 'string') return val;
                return String(val);
            };
            const bBuilding = s(b.buildingName);
            const bDate = s(b.firstDate || b.date);
            return bBuilding === buildingName && bDate === date &&
                (b.firstSlotUid === slotUid || b.secondSlotUid === slotUid);
        }).length;
    };


    const getGroupedBookings = () => {
        const groups = {};

        filteredBookings.forEach(b => {
            const s = (val) => {
                if (val === null || val === undefined) return '';
                if (typeof val === 'string') return val;
                if (val.seconds) return new Date(val.seconds * 1000).toLocaleString('en-GB');
                return String(val);
            };

            const building = s(b.buildingName);
            const date = s(b.firstDate || b.date);
            const timeFrom = s(b.firstDate_from);
            const timeTo = s(b.firstDate_to);
            const timeKey = `${timeFrom}-${timeTo}`;

            const key = `${building}|||${date}|||${timeKey}`;

            if (!groups[key]) {
                groups[key] = {
                    building,
                    date,
                    timeFrom,
                    timeTo,
                    bookings: [],
                    slotCounts: {}
                };
            }

            groups[key].bookings.push(b);

            if (b.firstSlotUid) {
                groups[key].slotCounts[b.firstSlotUid] = (groups[key].slotCounts[b.firstSlotUid] || 0) + 1;
            }
            if (b.secondSlotUid) {
                groups[key].slotCounts[b.secondSlotUid] = (groups[key].slotCounts[b.secondSlotUid] || 0) + 1;
            }
        });

        return Object.values(groups);
    };

    const handleDeleteBooking = async () => {
        if (!bookingToDelete) return;

        setDeleting(true);
        try {
            if (bookingToDelete.firstDate) {
                const [day1, month1, year1] = bookingToDelete.firstDate.split('/');
                const dateDocName1 = `${day1}-${month1}-${year1}`;
                const bookingRef1 = doc(db, 'inspections', bookingToDelete.buildingId, 'dates', dateDocName1, 'bookings', bookingToDelete.id);

                const dateDocRef1 = doc(db, 'inspections', bookingToDelete.buildingId, 'dates', dateDocName1);
                const dateDocSnap1 = await getDoc(dateDocRef1);

                if (dateDocSnap1.exists()) {
                    const data = dateDocSnap1.data();
                    const flatNumbers = (data.flatNumbers || []).filter(f => f !== bookingToDelete.flatNo);
                    const totalBookings = Math.max(0, (data.totalBookings || 1) - 1);

                    const currentTimeSlots = data.timeSlots || {};
                    const timeSlotKey = bookingToDelete.firstDate_from;

                    if (currentTimeSlots[timeSlotKey]) {
                        currentTimeSlots[timeSlotKey] = {
                            ...currentTimeSlots[timeSlotKey],
                            bookedCount: Math.max(0, (currentTimeSlots[timeSlotKey].bookedCount || 1) - 1)
                        };
                    }

                    await setDoc(dateDocRef1, {
                        flatNumbers,
                        totalBookings,
                        timeSlots: currentTimeSlots,
                        lastUpdated: serverTimestamp()
                    }, { merge: true });
                }

                await deleteDoc(bookingRef1);
            }

            if (bookingToDelete.secondDate && bookingToDelete.secondDate !== bookingToDelete.firstDate) {
                const [day2, month2, year2] = bookingToDelete.secondDate.split('/');
                const dateDocName2 = `${day2}-${month2}-${year2}`;
                const bookingRef2 = doc(db, 'inspections', bookingToDelete.buildingId, 'dates', dateDocName2, 'bookings', bookingToDelete.id);

                const dateDocRef2 = doc(db, 'inspections', bookingToDelete.buildingId, 'dates', dateDocName2);
                const dateDocSnap2 = await getDoc(dateDocRef2);

                if (dateDocSnap2.exists()) {
                    const data = dateDocSnap2.data();
                    const flatNumbers = (data.flatNumbers || []).filter(f => f !== bookingToDelete.flatNo);
                    const totalBookings = Math.max(0, (data.totalBookings || 1) - 1);

                    const currentTimeSlots = data.timeSlots || {};
                    const timeSlotKey = bookingToDelete.secondDate_from;

                    if (currentTimeSlots[timeSlotKey]) {
                        currentTimeSlots[timeSlotKey] = {
                            ...currentTimeSlots[timeSlotKey],
                            bookedCount: Math.max(0, (currentTimeSlots[timeSlotKey].bookedCount || 1) - 1)
                        };
                    }

                    await setDoc(dateDocRef2, {
                        flatNumbers,
                        totalBookings,
                        timeSlots: currentTimeSlots,
                        lastUpdated: serverTimestamp()
                    }, { merge: true });
                }

                await deleteDoc(bookingRef2);
            }

            setAllBookings(prev => prev.filter(b => b.id !== bookingToDelete.id));

            if (bookingToDelete.firstSlotUid) {
                setSlotCounts(prev => ({
                    ...prev,
                    [bookingToDelete.firstSlotUid]: Math.max(0, (prev[bookingToDelete.firstSlotUid] || 1) - 1)
                }));
            }
            if (bookingToDelete.secondSlotUid && bookingToDelete.secondDate !== bookingToDelete.firstDate) {
                setSlotCounts(prev => ({
                    ...prev,
                    [bookingToDelete.secondSlotUid]: Math.max(0, (prev[bookingToDelete.secondSlotUid] || 1) - 1)
                }));
            }

            setShowDeleteModal(false);
            setBookingToDelete(null);

        } catch (err) {
            console.error('Failed to delete booking:', err);
            alert('Failed to delete booking. Please try again.');
        } finally {
            setDeleting(false);
        }
    };

    const generateInspectionUid = (buildingName, date) => {
        const buildingPart = buildingName
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '_')
            .substring(0, 25);

        const [day, month, year] = date.split('/');
        const datePart = `${day}-${month}-${year}`;

        return `${buildingPart}_${datePart}`;
    };

    const generateBuildingDocName = (buildingName) => {
        return buildingName
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '_')
            .substring(0, 50);
    };

    const generateSlotUid = (buildingName, date, startTime) => {
        const buildingPart = buildingName
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '_')
            .substring(0, 25);

        const [day, month, year] = date.split('/');
        const datePart = `${day}-${month}-${year}`;

        const timePart = startTime.replace(':', '-');

        return `${buildingPart}_${datePart}_${timePart}`;
    };

    const divideIntoObitSlots = (startTime, endTime) => {
        const toMinutes = (t) => {
            const [h, m] = t.split(':').map(Number);
            return h * 60 + m;
        };
        const formatTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        };

        const startTotal = toMinutes(startTime);
        const endTotal = toMinutes(endTime);
        const midTotal = toMinutes('12:30');

        const morningChunk = (midTotal - startTotal) / 2;
        const morningSlots = [
            { startTime: formatTime(startTotal), endTime: formatTime(startTotal + morningChunk) },
            { startTime: formatTime(startTotal + morningChunk), endTime: formatTime(midTotal) }
        ];

        const afternoonChunk = (endTotal - midTotal) / 2;
        const afternoonSlots = [
            { startTime: formatTime(midTotal), endTime: formatTime(midTotal + afternoonChunk) },
            { startTime: formatTime(midTotal + afternoonChunk), endTime: formatTime(endTotal) }
        ];

        return [...morningSlots, ...afternoonSlots].map((slot, i) => ({ ...slot, index: i + 1 }));
    };
    const divideIntoObitFullDay = (startTime, endTime) => {
        return [{ startTime, endTime, index: 1 }];
    };

    const divideInto30MinSlots = (startTime, endTime) => {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        let startTotalMinutes = startHours * 60 + startMinutes;
        startTotalMinutes = Math.floor(startTotalMinutes / 30) * 30;

        const [endHours, endMinutes] = endTime.split(':').map(Number);
        let endTotalMinutes = endHours * 60 + endMinutes;
        endTotalMinutes = Math.ceil(endTotalMinutes / 30) * 30;

        const totalDuration = endTotalMinutes - startTotalMinutes;

        const formatTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        };

        if (totalDuration <= 0) {
            return [{
                startTime: formatTime(startTotalMinutes),
                endTime: formatTime(endTotalMinutes),
                index: 1
            }];
        }

        const SLOT_SIZE = 30;
        const numSlots = Math.ceil(totalDuration / SLOT_SIZE);

        const slots = [];
        for (let i = 0; i < numSlots; i++) {
            const slotStart = startTotalMinutes + i * SLOT_SIZE;
            const slotEnd = Math.min(slotStart + SLOT_SIZE, endTotalMinutes);

            slots.push({
                startTime: formatTime(slotStart),
                endTime: formatTime(slotEnd),
                index: i + 1
            });
        }
        return slots;
    };

    const divideIntoNSlots = (startTime, endTime, numSlots) => {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        let startTotalMinutes = startHours * 60 + startMinutes;
        startTotalMinutes = Math.ceil(startTotalMinutes / 10) * 10;

        const [endHours, endMinutes] = endTime.split(':').map(Number);
        let endTotalMinutes = endHours * 60 + endMinutes;
        endTotalMinutes = Math.floor(endTotalMinutes / 10) * 10;

        const totalDuration = endTotalMinutes - startTotalMinutes;

        const formatTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        };

        if (totalDuration <= 0) {
            return [{
                startTime: formatTime(startTotalMinutes),
                endTime: formatTime(endTotalMinutes),
                index: 1
            }];
        }

        const chunk = totalDuration / numSlots;

        const slots = [];
        for (let i = 0; i < numSlots; i++) {
            let slotStart = startTotalMinutes + i * chunk;
            let slotEnd = (i === numSlots - 1) ? endTotalMinutes : startTotalMinutes + (i + 1) * chunk;

            slotStart = Math.round(slotStart / 10) * 10;
            slotEnd = Math.round(slotEnd / 10) * 10;

            slots.push({
                startTime: formatTime(slotStart),
                endTime: formatTime(slotEnd),
                index: i + 1
            });
        }
        return slots;
    };

    const divideIntoHalves = (startTime, endTime) => {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        let startTotalMinutes = startHours * 60 + startMinutes;
        startTotalMinutes = Math.ceil(startTotalMinutes / 10) * 10;

        const [endHours, endMinutes] = endTime.split(':').map(Number);
        let endTotalMinutes = endHours * 60 + endMinutes;
        endTotalMinutes = Math.floor(endTotalMinutes / 10) * 10;

        const totalDuration = endTotalMinutes - startTotalMinutes;

        const formatTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        };

        if (totalDuration <= 0) {
            return [{
                startTime: formatTime(startTotalMinutes),
                endTime: formatTime(endTotalMinutes),
                index: 1
            }];
        }

        const NUM_SLOTS = 2;
        const half = totalDuration / NUM_SLOTS;

        const slots = [];
        for (let i = 0; i < NUM_SLOTS; i++) {
            let slotStart = startTotalMinutes + i * half;
            let slotEnd = (i === NUM_SLOTS - 1) ? endTotalMinutes : startTotalMinutes + (i + 1) * half;

            slotStart = Math.round(slotStart / 10) * 10;
            slotEnd = Math.round(slotEnd / 10) * 10;

            slots.push({
                startTime: formatTime(slotStart),
                endTime: formatTime(slotEnd),
                index: i + 1
            });
        }
        return slots;
    };

    const divideTimeIntoSlots = (startTime, endTime) => {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        let startTotalMinutes = startHours * 60 + startMinutes;
        startTotalMinutes = Math.ceil(startTotalMinutes / 10) * 10;

        const [endHours, endMinutes] = endTime.split(':').map(Number);
        let endTotalMinutes = endHours * 60 + endMinutes;
        endTotalMinutes = Math.floor(endTotalMinutes / 10) * 10;

        const totalDuration = endTotalMinutes - startTotalMinutes;

        const SLOT_DURATION = 60;
        const numSlots = Math.floor(totalDuration / SLOT_DURATION);

        if (numSlots === 0) {
            return [{
                startTime: `${String(Math.floor(startTotalMinutes / 60)).padStart(2, '0')}:${String(startTotalMinutes % 60).padStart(2, '0')}`,
                endTime: `${String(Math.floor(endTotalMinutes / 60)).padStart(2, '0')}:${String(endTotalMinutes % 60).padStart(2, '0')}`,
                index: 1
            }];
        }

        const slots = [];

        for (let i = 0; i < numSlots; i++) {
            let slotStart = startTotalMinutes + (i * SLOT_DURATION);
            let slotEnd = slotStart + SLOT_DURATION;

            if (i === numSlots - 1) {
                slotEnd = endTotalMinutes;
            }

            slotStart = Math.round(slotStart / 10) * 10;
            slotEnd = Math.round(slotEnd / 10) * 10;

            const formatTime = (minutes) => {
                const hours = Math.floor(minutes / 60);
                const mins = minutes % 60;
                return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
            };

            slots.push({
                startTime: formatTime(slotStart),
                endTime: formatTime(slotEnd),
                index: i + 1
            });
        }

        return slots;
    };

    const fetchCalendarSlots = async (userId = 'rxaqnUdohkQBw3ZiH77vl2Eu4rT2') => {

        setLoading(true);
        try {
            const calendarCol = collection(db, "users", userId, "calendar");

            const [snapshot, bookingsSnapshot] = await Promise.all([
                getDocs(calendarCol),
                getDocs(collectionGroup(db, "bookings")),
            ]);

            const bookingCounts = {};
            bookingsSnapshot.forEach(bookingDoc => {
                const data = bookingDoc.data();
                if (data.firstSlotUid) {
                    bookingCounts[data.firstSlotUid] = (bookingCounts[data.firstSlotUid] || 0) + 1;
                }
                if (data.secondSlotUid) {
                    bookingCounts[data.secondSlotUid] = (bookingCounts[data.secondSlotUid] || 0) + 1;
                }
            });

            setSlotCounts(bookingCounts);

            if (snapshot.empty) {
                setLoading(false);
                return {};
            }

            const looksLikeBuilding = (text) => {
                const lowerText = text.toLowerCase().trim();

                if (lowerText.length < 3) return false;

                if (/^[a-z]{1,4}$/.test(lowerText)) return false;

                if (/^[a-z]{1,4}\d+$/.test(lowerText)) return false;

                if (!text.includes(' ') && lowerText.length <= 8) {
                    const hasRealWordPattern = /[aeiou].{2,}/.test(lowerText);
                    if (!hasRealWordPattern && /^[a-z]+$/.test(lowerText)) return false;
                }

                if (/(.)\1{3,}/.test(lowerText)) return false;

                const hasNumber = /\d/.test(text);
                const hasStreetSuffix = /\b(street|st|road|rd|avenue|ave|drive|dr|lane|ln|court|ct|boulevard|blvd|way|place|pl|square|sq|circle|cir)\b/i.test(text);
                const hasBuildingWord = /\b(building|bldg|tower|plaza|centre|center|house|hall|complex|offices|suite|ste|floor|fl|unit)\b/i.test(text);
                const hasProperCapitalization = text.split(' ').some(word => word.length > 2 && word[0] === word[0].toUpperCase() && word !== word.toUpperCase());

                if (hasNumber || hasStreetSuffix || hasBuildingWord) return true;

                if (hasProperCapitalization && text.length > 5) return true;

                const nonBuildingKeywords = [
                    'bank holiday', 'holiday', 'leave', 'sick', 'appointment',
                    'meeting', 'call', 'lunch', 'break', 'wfh', 'remote',
                    'vacation', 'off', 'busy', 'unavailable', 'reserved',
                    'xx', 'test', 'example', 'sample', 'pending', 'tbd'
                ];

                if (nonBuildingKeywords.some(keyword => lowerText.includes(keyword))) {
                    return false;
                }

                if (!text.includes(' ') && !hasNumber && !hasBuildingWord && !hasStreetSuffix) {
                    const commonNames = ['reception', 'lobby', 'main', 'north', 'south', 'east', 'west'];
                    if (!commonNames.includes(lowerText) && !hasProperCapitalization) {
                        return false;
                    }
                }

                return true;
            };

            const availableSlots = {};
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const processedSlots = new Set();

            const buildingNameCache = new Map();

            snapshot.forEach((doc) => {
                const slotData = doc.data();
                const { buildingAddress, start, end, category, travelTimeMinutes, title } = slotData;

                if (category && category.toLowerCase() !== 'general' && category.toLowerCase() !== 'inspection') {
                    return;
                }

                const communcalDoors = Number(slotData.totalCommunalDoors);
                const resiDoors = Number(slotData.totalResiDoors);

                if (communcalDoors > 0 && resiDoors === 0) {
                    return;
                }

                if (!buildingAddress || !start || !end) {
                    return;
                }

                const [datePart, timePart] = start.split(' ');
                const [day, month, year] = datePart.split('/');
                const slotDate = new Date(year, month - 1, day);

                if (slotDate <= today) {
                    return;
                }

                const buildingName = buildingAddress.split(',')[0].trim();

                let isValidBuilding = buildingNameCache.get(buildingName);
                if (isValidBuilding === undefined) {
                    isValidBuilding = looksLikeBuilding(buildingName);
                    buildingNameCache.set(buildingName, isValidBuilding);
                }
                if (!isValidBuilding) {
                    return;
                }

                const startTime = timePart;
                const endTime = end.split(' ')[1];

                const travelMins = travelTimeMinutes ? Number(travelTimeMinutes) : 0;

                const addMinutesToTime = (time24, addMinutes) => {
                    const [hours, minutes] = time24.split(':').map(Number);
                    const totalMinutes = hours * 60 + minutes + addMinutes;

                    const rounded = Math.ceil(totalMinutes / 10) * 10;
                    const newHours = Math.floor(rounded / 60);
                    const newMinutes = rounded % 60;
                    return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
                };

                const adjustedStartTime = addMinutesToTime(startTime, travelMins);

                const slotKey = `${buildingName}_${datePart}_${adjustedStartTime}_${endTime}`;

                if (processedSlots.has(slotKey)) {
                    return;
                }
                processedSlots.add(slotKey);

                if (!availableSlots[buildingName]) {
                    availableSlots[buildingName] = {};
                }

                if (!availableSlots[buildingName][datePart]) {
                    availableSlots[buildingName][datePart] = [];
                }

                const isDolphinCourt =
                    (buildingAddress || '').trim() === 'Dolphin Court, 12-16 Southey Road' &&
                    (title || '').trim() === 'DOLPHIN COURT';

                const isReinspectionDay =
                    (title || '').trim().toUpperCase() === 'REINSPECTION DAY' ||
                    (buildingAddress || '').trim().toUpperCase() === 'REINSPECTION DAY';

                const isWesthallManor =
                    (title || '').trim().toUpperCase() === 'WESTHALL MANOR' ||
                    (buildingName || '').trim().toUpperCase() === 'WESTHALL MANOR';

                const dayOfMonth = isWesthallManor ? parseInt((datePart || '').split('-').pop(), 10) : null;

                const westhallSlotCount =
                    dayOfMonth === 10 || dayOfMonth === 11 ? 4 :
                        dayOfMonth === 12 || dayOfMonth === 13 ? 2 :
                            null;

                // orbit
                const isOrbit = (buildingName || '').trim() === 'Orbit';

                const dateParts = (datePart || '').split('/').map(Number);
                const orbitDayNum = dateParts[0];
                const orbitMonth = dateParts[1];

                const isOrbitTwoWindowDay =
                    isOrbit && orbitMonth === 9 && [21, 22, 24, 26].includes(orbitDayNum);

                const isOrbitMorningOnlyDay =
                    isOrbit && orbitMonth === 9 && orbitDayNum === 23;

                const isOrbitOneCarpenterDay =
                    isOrbit &&
                    ((orbitMonth === 9 && [28, 29, 30].includes(orbitDayNum)) ||
                        (orbitMonth === 10 && orbitDayNum === 1));

                const timeSlots = isDolphinCourt
                    ? divideIntoHalves(adjustedStartTime, endTime)
                    : isReinspectionDay
                        ? divideInto30MinSlots(adjustedStartTime, endTime)
                        : (isWesthallManor && westhallSlotCount)
                            ? divideIntoNSlots(adjustedStartTime, endTime, westhallSlotCount)
                            : (isOrbitTwoWindowDay || isOrbitOneCarpenterDay)
                                ? divideIntoHalves(adjustedStartTime, endTime)
                                : isOrbitMorningOnlyDay
                                    ? divideIntoObitFullDay(adjustedStartTime, endTime)
                                    : divideTimeIntoSlots(adjustedStartTime, endTime);

                // const timeSlots = divideTimeIntoSlots(adjustedStartTime, endTime);

                timeSlots.forEach(slot => {
                    const slotUid = generateSlotUid(buildingName, datePart, slot.startTime);
                    const inspectionUid = generateInspectionUid(buildingName, datePart);

                    availableSlots[buildingName][datePart].push({
                        uid: slotUid,
                        inspectionUid: inspectionUid,
                        date: datePart,
                        startTime: slot.startTime,
                        endTime: slot.endTime,
                        travelTimeMinutes: travelMins,
                        slotNumber: slot.index,
                        totalSlots: timeSlots.length,
                        display: `${formatTime(slot.startTime)} to ${formatTime(slot.endTime)}`,
                        value: slotUid,
                        maxCapacity: isDolphinCourt
                            ? 2
                            : (isReinspectionDay
                                ? 1
                                : (isWesthallManor && westhallSlotCount
                                    ? westhallSlotCount
                                    : isOrbitTwoWindowDay
                                        ? 2
                                        : isOrbitMorningOnlyDay
                                            ? 2
                                            : isOrbitOneCarpenterDay
                                                ? 1
                                                : 8))
                    });
                });
            });

            const sortedSlots = {};
            const sortedBuildings = Object.keys(availableSlots).sort((a, b) => {
                const aStartsWithDigit = /^\d/.test(a);
                const bStartsWithDigit = /^\d/.test(b);

                if (aStartsWithDigit && !bStartsWithDigit) return -1;
                if (!aStartsWithDigit && bStartsWithDigit) return 1;

                if (aStartsWithDigit && bStartsWithDigit) {
                    const aNum = parseInt(a.match(/^\d+/)[0]) || 0;
                    const bNum = parseInt(b.match(/^\d+/)[0]) || 0;
                    if (aNum !== bNum) return aNum - bNum;
                }

                return a.localeCompare(b);
            });

            sortedBuildings.forEach(building => {
                const sortedDates = {};
                Object.keys(availableSlots[building])
                    .sort((a, b) => {
                        const [dayA, monthA, yearA] = a.split('/');
                        const [dayB, monthB, yearB] = b.split('/');
                        return new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB);
                    })
                    .forEach(date => {
                        sortedDates[date] = availableSlots[building][date].sort((a, b) => {
                            return a.startTime.localeCompare(b.startTime);
                        });
                    });

                sortedSlots[building] = sortedDates;
            });

            return sortedSlots;
        } catch (error) {
            console.error('Error fetching calendar slots:', error);
            return {};
        } finally {
            setLoading(false);
        }
    };

    const formatTime = (time24) => {
        const [hours, minutes] = time24.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };

    useEffect(() => {
        const loadSlots = async () => {
            const slots = await fetchCalendarSlots('rxaqnUdohkQBw3ZiH77vl2Eu4rT2', true);
            setCalendarSlots(slots);
            setBuildings(Object.keys(slots));
        };
        loadSlots();
    }, []);

    const lastFetchRef = useRef(0);

    useEffect(() => {
        const handleFocus = async () => {
            const now = Date.now();
            if (now - lastFetchRef.current > 300000) {
                lastFetchRef.current = now;
                const slots = await fetchCalendarSlots('rxaqnUdohkQBw3ZiH77vl2Eu4rT2', false);
                setCalendarSlots(slots);
                setBuildings(Object.keys(slots));
            }
        };

        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, []);

    useEffect(() => {
        if (buildingName && calendarSlots[buildingName]) {
            const dates = Object.keys(calendarSlots[buildingName]);
            setAvailableDates(dates);
            setSelectedDate("");
            setSelectedTimeSlot("");
            setAvailableTimeSlots([]);
        } else {
            setAvailableDates([]);
            setSelectedDate("");
            setSelectedTimeSlot("");
            setAvailableTimeSlots([]);
        }
    }, [buildingName, calendarSlots]);

    useEffect(() => {
        if (selectedDate && buildingName && calendarSlots[buildingName]?.[selectedDate]) {
            setAvailableTimeSlots(calendarSlots[buildingName][selectedDate]);
            setSelectedTimeSlot("");
        } else {
            setAvailableTimeSlots([]);
            setSelectedTimeSlot("");
        }
    }, [selectedDate, buildingName, calendarSlots]);

    const getAvailableDates = () => {
        if (!buildingName || !calendarSlots[buildingName]) return [];
        return Object.keys(calendarSlots[buildingName]);
    };

    const getAvailableTimeSlots = () => {
        if (!selectedDate || !buildingName || !calendarSlots[buildingName]?.[selectedDate]) return [];
        return calendarSlots[buildingName][selectedDate];
    };

    const getAvailableTimeSlotsForSecond = () => {
        if (!selectedSecondDate || !buildingName || !calendarSlots[buildingName]?.[selectedSecondDate]) return [];
        return calendarSlots[buildingName][selectedSecondDate];
    };

    const handleTimeSlotChange = (value) => {
        setSelectedTimeSlot(value);
    };

    const getSlotData = (slotValue) => {
        if (!slotValue || !buildingName || !calendarSlots[buildingName]) return null;

        for (const date of Object.keys(calendarSlots[buildingName])) {
            const slot = calendarSlots[buildingName][date].find(s => s.uid === slotValue);
            if (slot) return slot;
        }
        return null;
    };

    const handleBuildingChange = (selected) => {
        setBuildingName(selected?.value || "");
        setFlatNo("");
        setFirstDate("");
        setSecondDate("");
        setEmail("");
        setPhone("");
        setTenantEmail("");
        setTenantPhone("");
        setKeyGivenToManager(true);
        setKeyDetails("");
        setUnavailableReason("");
        setUnavailableDetails("");
        setUnavailableDate("");
    };

    const handleFlatNoChange = (e) => {
        setFlatNo(e.target.value);
    };

    const resetBookingForm = () => {
        setBuildingName("");
        setFlatNo("");
        setSelectedDate("");
        setSelectedTimeSlot("");
        setSelectedSecondDate("");
        setSelectedSecondTimeSlot("");
        setEmail("");
        setPhone("");
        setKeyGivenToManager(true);
        setKeyDetails("");
        setAgreedToTerms(false);
        setSubmitted(false);
        setSubmittedUnavailable(false);
        setTenantEmail("");
        setTenantPhone("");
        setBookingType("tenant");
        setNotAvailable(false);
        setUnavailableReason("");
        setUnavailableDetails("");
        setUnavailableDate("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!buildingName || !flatNo.trim() || !email.trim() || !phone.trim()) {
            alert("Please fill in your building, flat, email, and phone number.");
            return;
        }

        if (!agreedToTerms) {
            alert("Please agree to the Terms and Conditions");
            return;
        }

        if (notAvailable) {
            if (!isValidDateKey(unavailableDate) || unavailableDate < todayKey) {
                alert("Please select today or a future date when you are unavailable.");
                return;
            }
            if (!unavailableReason) {
                alert("Please select why you are unavailable.");
                return;
            }
            if (unavailableReason === 'other' && !unavailableDetails.trim()) {
                alert("Please provide a brief explanation.");
                return;
            }
            setLoading(true);
            try {
                const inspectionsCol = collection(db, "inspections");
                const existing = await getDocs(query(inspectionsCol, where("buildingName", "==", buildingName)));
                let buildingDocRef;
                if (existing.empty) {
                    buildingDocRef = doc(inspectionsCol);
                    await setDoc(buildingDocRef, { buildingName, createdAt: serverTimestamp() });
                } else {
                    buildingDocRef = existing.docs[0].ref;
                }
                const response = {
                    buildingName,
                    flatNo: flatNo.trim(),
                    email: email.trim(),
                    phone: phone.trim(),
                    bookingType,
                    status: "not_available",
                    unavailableDate,
                    reason: unavailableReason,
                    details: unavailableDetails.trim(),
                    agreedToTerms,
                    submittedAt: serverTimestamp(),
                    ...(bookingType === "landlord" ? { tenantEmail, tenantPhone } : {}),
                };
                await addDoc(collection(db, "inspections", buildingDocRef.id, "unavailableResponses"), response);
                await setDoc(buildingDocRef, { updatedAt: serverTimestamp() }, { merge: true });
                setSubmittedUnavailable(true);
                setSubmitted(true);
                setTimeout(resetBookingForm, 3000);
            } catch (err) {
                console.error("Firestore unavailable response error:", err);
                alert("Unable to submit your response. Please try again.");
            } finally {
                setLoading(false);
            }
            return;
        }

        if (!selectedTimeSlot && !selectedSecondTimeSlot) {
            alert("Please fill all fields and select at least one time slot");
            return;
        }

        if (keyGivenToManager && !keyDetails.trim()) {
            alert("Please enter where the keys can be found or who they have been left with.");
            return;
        }

        if (!agreedToTerms) {
            alert("Please agree to the Terms and Conditions");
            return;
        }

        const firstSlot = selectedTimeSlot ? getSlotData(selectedTimeSlot) : null;
        const secondSlot = selectedSecondTimeSlot ? getSlotData(selectedSecondTimeSlot) : null;

        if ((selectedTimeSlot && !firstSlot) || (selectedSecondTimeSlot && !secondSlot)) {
            alert("Invalid slot selection");
            return;
        }

        if (firstSlot && (slotCounts[firstSlot.uid] || 0) >= 8) {
            alert("This date is fully booked. Please select another date.");
            return;
        }
        if (secondSlot && (slotCounts[secondSlot.uid] || 0) >= 8) {
            alert("This date is fully booked. Please select another date.");
            return;
        }

        setLoading(true);

        try {
            const [day1, month1, year1] = firstSlot.date.split('/');
            const dateDocName1 = `${day1}-${month1}-${year1}`;

            const inspectionsCol = collection(db, "inspections");
            const q = query(inspectionsCol, where("buildingName", "==", buildingName));
            const querySnapshot = await getDocs(q);

            let buildingDocRef;

            if (!querySnapshot.empty) {
                buildingDocRef = querySnapshot.docs[0].ref;
            } else {
                buildingDocRef = doc(inspectionsCol);
                await setDoc(buildingDocRef, {
                    buildingName: buildingName,
                    createdAt: serverTimestamp()
                });
            }

            const bookingData = {
                flatNo,
                email,
                phone,
                buildingName,
                firstDate: firstSlot.date,
                firstDate_from: firstSlot.startTime,
                firstDate_to: firstSlot.endTime,
                firstSlotUid: firstSlot.uid,
                inspectionUid: firstSlot.inspectionUid,
                keyGivenToManager,
                keyDetails: keyGivenToManager ? keyDetails.trim() : "",
                agreedToTerms,
                submittedAt: serverTimestamp(),
            };

            if (bookingType === "landlord") {
                bookingData.tenantEmail = tenantEmail;
                bookingData.tenantPhone = tenantPhone;
            }

            if (secondSlot) {
                bookingData.secondDate = secondSlot.date;
                bookingData.secondDate_from = secondSlot.startTime;
                bookingData.secondDate_to = secondSlot.endTime;
                bookingData.secondSlotUid = secondSlot.uid;
            }

            const bookingsCol1 = collection(db, "inspections", buildingDocRef.id, "dates", dateDocName1, "bookings");
            const bookingDoc1 = await addDoc(bookingsCol1, bookingData);

            const dateDocRef1 = doc(db, "inspections", buildingDocRef.id, "dates", dateDocName1);
            const dateDocSnap1 = await getDoc(dateDocRef1);

            const currentBookings1 = dateDocSnap1.exists() ? (dateDocSnap1.data().totalBookings || 0) : 0;
            const currentFlats1 = dateDocSnap1.exists() ? (dateDocSnap1.data().flatNumbers || []) : [];

            if (!currentFlats1.includes(flatNo)) {
                currentFlats1.push(flatNo);
            }

            await setDoc(dateDocRef1, {
                date: firstSlot.date,
                buildingName: buildingName,
                inspectionUid: firstSlot.inspectionUid,
                totalBookings: currentBookings1 + 1,
                flatNumbers: currentFlats1,
                timeSlots: {
                    [firstSlot.startTime]: {
                        startTime: firstSlot.startTime,
                        endTime: firstSlot.endTime,
                        bookedCount: (slotCounts[firstSlot.uid] || 0) + 1
                    }
                },
                lastUpdated: serverTimestamp(),
                createdAt: dateDocSnap1.exists() ? dateDocSnap1.data().createdAt : serverTimestamp()
            }, { merge: true });


            await setDoc(buildingDocRef, {
                updatedAt: serverTimestamp(),
                // totalBookings: increment(1)
            }, { merge: true });

            if (secondSlot) {
                const [day2, month2, year2] = secondSlot.date.split('/');
                const dateDocName2 = `${day2}-${month2}-${year2}`;

                if (dateDocName2 !== dateDocName1) {
                    const bookingsCol2 = collection(db, "inspections", buildingDocRef.id, "dates", dateDocName2, "bookings");
                    const bookingDoc2 = await addDoc(bookingsCol2, bookingData);

                    const dateDocRef2 = doc(db, "inspections", buildingDocRef.id, "dates", dateDocName2);
                    const dateDocSnap2 = await getDoc(dateDocRef2);

                    const currentBookings2 = dateDocSnap2.exists() ? (dateDocSnap2.data().totalBookings || 0) : 0;
                    const currentFlats2 = dateDocSnap2.exists() ? (dateDocSnap2.data().flatNumbers || []) : [];

                    if (!currentFlats2.includes(flatNo)) {
                        currentFlats2.push(flatNo);
                    }

                    await setDoc(dateDocRef2, {
                        date: secondSlot.date,
                        buildingName: buildingName,
                        inspectionUid: secondSlot.inspectionUid,
                        totalBookings: currentBookings2 + 1,
                        flatNumbers: currentFlats2,
                        timeSlots: {
                            [secondSlot.startTime]: {
                                startTime: secondSlot.startTime,
                                endTime: secondSlot.endTime,
                                bookedCount: (slotCounts[secondSlot.uid] || 0) + 1
                            }
                        },
                        lastUpdated: serverTimestamp(),
                        createdAt: dateDocSnap2.exists() ? dateDocSnap2.data().createdAt : serverTimestamp()
                    }, { merge: true });
                }
            }

            setSlotCounts(prev => ({
                ...prev,
                [firstSlot.uid]: (prev[firstSlot.uid] || 0) + 1,
                ...(secondSlot ? { [secondSlot.uid]: (prev[secondSlot.uid] || 0) + 1 } : {})
            }));

            setSubmittedUnavailable(false);
            setSubmitted(true);

            setTimeout(() => {
                setBuildingName("");
                setFlatNo("");
                setSelectedDate("");
                setSelectedTimeSlot("");
                setSelectedSecondDate("");
                setSelectedSecondTimeSlot("");
                setEmail("");
                setPhone("");
                setKeyGivenToManager(true);
                setKeyDetails("");
                setAgreedToTerms(false);
                setSubmitted(false);
                setTenantEmail("");
                setTenantPhone("");
                setBookingType("tenant");
                setNotAvailable(false);
                setUnavailableReason("");
                setUnavailableDetails("");
                setUnavailableDate("");
            }, 3000);

        } catch (err) {
            console.error("Firestore submission error:", err);
            alert("Error submitting booking. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const getAvailableSlots = () => {
        if (!buildingName || !availableSlots[buildingName]) {
            return [];
        }
        return availableSlots[buildingName];
    };


    const options = buildings.map(b => ({ label: b, value: b }));

    const selectStyles = {
        control: (provided, { isFocused }) => ({
            ...provided,
            borderRadius: "0.375rem",
            padding: "0 0.5rem",
            borderColor: isFocused ? "#dc3545" : "#ced4da",
            boxShadow: isFocused ? "0 0 0 0.2rem rgba(220,53,69,.25)" : "none",
            minHeight: "40px",
            height: "40px",
            outline: "none",
            "&:hover": { borderColor: "#dc3545" },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: 'pointer',
        }),
        menu: (provided) => ({
            ...provided,
            maxWidth: "600px",
        }),
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            backgroundColor: isSelected
                ? "#dc3545"
                : isFocused
                    ? "#ffe5e5"
                    : "white",
            color: isSelected ? "white" : "#333",
            cursor: "pointer",
            minHeight: "38px",
            display: "flex",
            alignItems: "center",
            "&:active": { backgroundColor: "#dc3545" },
        }),
        singleValue: provided => ({
            ...provided,
            color: "#282828ff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        placeholder: provided => ({
            ...provided,
            color: "#282828ff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        dropdownIndicator: provided => ({
            ...provided,
            color: "#a71d2a",
            "&:hover": { color: "#dc3545" },
        }),
        clearIndicator: provided => ({
            ...provided,
            color: "#a71d2a",
            "&:hover": { color: "#dc3545" },
        }),
        menuPortal: base => ({ ...base, zIndex: 99999 }),
    };

    if (loading) return (
        <div className="loading-container">
            <ClipLoader color="#b11111" size={60} />
            <div className="loading-text">
                {displayedText}
                <span className="cursor">|</span>
            </div>
        </div>
    );

    const termsModalStyles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            boxSizing: 'border-box',
        },

        content: {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            margin: 0,
            padding: 0,
            transform: 'none',
            width: '100%',
            maxWidth: '700px',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
            border: 'none',
            borderRadius: '12px',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
            overflow: 'hidden',
            boxSizing: 'border-box',
        },
    };

    const exportToExcel = () => {
        const headers = [
            '#', 'Availability', 'Building', 'Flat', 'Date', 'Time Slot',
            'Email', 'Phone', 'Landlord', 'Tenant Email', 'Tenant Phone',
            'Keys', 'Key Details', 'Terms', 'Status', 'Email Sent', 'Submitted At'
        ];

        const colWidths = [
            { wch: 5 },
            { wch: 10 },
            { wch: 25 },
            { wch: 8 },
            { wch: 14 },
            { wch: 22 },
            { wch: 28 },
            { wch: 16 },
            { wch: 10 },
            { wch: 28 },
            { wch: 16 },
            { wch: 6 },
            { wch: 36 },
            { wch: 7 },
            { wch: 12 },
            { wch: 12 },
            { wch: 18 }
        ];

        const groups = getGroupedBookings();
        let rowIndex = 0;
        const rows = [];

        groups.forEach(group => {
            const totalSlotsTaken = group.bookings.length;
            const slotsRemaining = 8 - totalSlotsTaken;
            const isFull = slotsRemaining <= 0;
            const availability = isFull ? 'FULL' : `${slotsRemaining} left`;

            group.bookings.forEach((b, idx) => {
                rowIndex++;
                const s = (val) => {
                    if (val === null || val === undefined) return '';
                    if (typeof val === 'string') return val;
                    if (val.seconds) return new Date(val.seconds * 1000).toLocaleString('en-GB');
                    return String(val);
                };

                const timeSlot = (() => {
                    const from1 = s(b.firstDate_from);
                    const to1 = s(b.firstDate_to);
                    const from2 = s(b.secondDate_from);
                    const to2 = s(b.secondDate_to);
                    let result = '';
                    if (from1) result += `${from1} - ${to1 || '?'}`;
                    if (from2) result += (result ? ' | 2nd: ' : '') + `${from2} - ${to2 || '?'}`;
                    return result || '';
                })();

                const dateStr = s(b.firstDate || b.date);

                const created = (() => {
                    const c = b.createdAt || b.submittedAt;
                    if (!c) return '';
                    if (c.seconds) return new Date(c.seconds * 1000).toLocaleString('en-GB');
                    return s(c);
                })();

                rows.push([
                    rowIndex,
                    idx === 0
                        ? (isFull ? 'FULL' : `${slotsRemaining} left`)
                        : (isFull ? 'FULL (see above)' : `${slotsRemaining} left (see above)`),
                    s(b.buildingName),
                    s(b.flatNo),
                    dateStr,
                    timeSlot,
                    s(b.email),
                    s(b.phone),
                    (s(b.tenantEmail) || s(b.tenantPhone)) ? 'Yes' : 'No',
                    s(b.tenantEmail),
                    s(b.tenantPhone),
                    b.keyGivenToManager ? 'Yes' : 'No',
                    s(b.keyDetails),
                    b.agreedToTerms ? 'Yes' : 'No',
                    b.firstSlotUid ? 'Confirmed' : 'Pending',
                    (b.emailSent === true || b.emailSent === 'yes') ? 'Yes' : 'No',
                    created
                ]);
            });
        });

        const data = [headers, ...rows];

        const ws = XLSX.utils.aoa_to_sheet(data);
        ws['!cols'] = colWidths;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Bookings');

        XLSX.writeFile(wb, `bookings_export_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    return (
        <div className="book-inspection-wrapper">
            <div className="book-inspection-container">
                <div className="inspection-header">
                    <h1 className="header-title" style={{ fontSize: 'clamp(1.5rem, 5vw, 2rem)' }}>
                        <FontAwesomeIcon icon={faClock} className="header-icon" />
                        Book Your Inspection
                    </h1>
                    <p className="header-description" style={{ paddingTop: '10px', fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}>
                        Schedule your door inspection at a time that suits you best.
                    </p>
                    <p className="header-subtitle" style={{ fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)' }}>
                        If you have any questions, feel free to call us at{' '}
                        <a href="tel:01483338356" style={{ color: 'red', wordBreak: 'break-word' }}>01483 338356</a> or email us at{' '}
                        <a href="mailto:alexh@firechecked.co.uk" style={{ color: 'red', wordBreak: 'break-all' }}>
                            alexh@firechecked.co.uk
                        </a>
                    </p>
                    <div style={{ marginTop: '8px' }}>
                        <a href="/privacy-policy" style={{
                            display: 'inline-block',
                            backgroundColor: '#f8f9fa',
                            color: '#b30000',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                            textDecoration: 'none',
                            border: '1px solid #b30000',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer'
                        }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#b30000';
                                e.target.style.color = '#ffffff';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.color = '#b30000';
                            }}
                        >
                            <FontAwesomeIcon icon={faShieldAlt} style={{ marginRight: '6px' }} />
                            Privacy Policy
                        </a>
                    </div>
                </div>

                {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator') && (
                    <Nav
                        variant="tabs"
                        className="mb-4 admin-tabs"
                        activeKey={activeTab}
                        onSelect={setActiveTab}
                        style={{
                            flexWrap: 'nowrap',
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            whiteSpace: 'nowrap',
                            gap: '8px',
                            WebkitOverflowScrolling: 'touch',
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none'
                        }}
                    >
                        <Nav.Item style={{ flex: '0 0 auto' }}>
                            <Nav.Link
                                eventKey="book"
                                style={{
                                    padding: '10px 16px',
                                    fontSize: 'clamp(0.85rem, 2.5vw, 1rem)',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <FontAwesomeIcon icon={faCalendar} className="me-2" />
                                Book Inspection
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item style={{ flex: '0 0 auto' }}>
                            <Nav.Link
                                eventKey="view"
                                style={{
                                    padding: '10px 16px',
                                    fontSize: 'clamp(0.85rem, 2.5vw, 1rem)',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <FontAwesomeIcon icon={faList} className="me-2" />
                                View All Bookings ({allBookings.length})
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item style={{ flex: '0 0 auto' }}>
                            <Nav.Link eventKey="unavailable">Not Available ({unavailableResponses.length})</Nav.Link>
                        </Nav.Item>
                    </Nav>
                )}

                {activeTab === 'book' && (
                    <>
                        {submitted && (
                            <div className="success-message" style={{ marginBottom: '40px', textAlign: 'center', padding: '20px 15px' }}>
                                <div className="success-icon">✓</div>
                                <h3 style={{ fontSize: 'clamp(1.2rem, 4vw, 1.5rem)' }}>Request Submitted Successfully!</h3>
                                <p style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}>{submittedUnavailable
                                    ? "Your unavailability has been recorded. No appointment has been booked."
                                    : "We'll contact you shortly to confirm your inspection appointment."}</p>
                            </div>
                        )}


                        <Card className="inspection-card">
                            <Card.Body style={{ padding: 'clamp(15px, 4vw, 24px)' }}>
                                <Form onSubmit={handleSubmit} className="inspection-form">
                                    <Row className="mb-4">
                                        <Col xs={12}>
                                            {/* A native radio group with the entire card as its label.
                                                Unlike Bootstrap Form.Check, the radio cannot float outside the card. */}
                                            <fieldset className="appointment-response-fieldset mb-3" disabled={loading}>
                                                <legend className="form-label-custom appointment-response-legend">Appointment response</legend>
                                                <div className="appointment-response-options">
                                                    <label className={`appointment-response-option ${!notAvailable ? 'is-selected' : ''}`}>
                                                        <input
                                                            type="radio"
                                                            name="appointmentResponse"
                                                            value="book"
                                                            checked={!notAvailable}
                                                            onChange={() => setNotAvailable(false)}
                                                            className="appointment-response-native-radio"
                                                        />
                                                        <span className="appointment-response-title">Book an appointment</span>
                                                        <span className="appointment-response-selected-mark" aria-hidden="true">✓</span>
                                                    </label>
                                                    <label className={`appointment-response-option ${notAvailable ? 'is-selected' : ''}`}>
                                                        <input
                                                            type="radio"
                                                            name="appointmentResponse"
                                                            value="unavailable"
                                                            checked={notAvailable}
                                                            onChange={() => {
                                                                setNotAvailable(true);
                                                                setSelectedDate("");
                                                                setSelectedTimeSlot("");
                                                                setSelectedSecondDate("");
                                                                setSelectedSecondTimeSlot("");
                                                            }}
                                                            className="appointment-response-native-radio"
                                                        />
                                                        <span className="appointment-response-title">Not Available</span>
                                                        <span className="appointment-response-selected-mark" aria-hidden="true">✓</span>
                                                    </label>
                                                </div>
                                            </fieldset>
                                            {notAvailable && (
                                                <div className="unavailable-details-panel p-3 mb-3 rounded">
                                                    <p className="mb-2">Unable to attend? Tell us why instead of sending an email. No appointment will be reserved.</p>
                                                    <Form.Group className="mb-3" controlId="unavailable-date">
                                                        <Form.Label>Date you are unavailable</Form.Label>
                                                        <Form.Control type="date" value={unavailableDate}
                                                            min={todayKey} onChange={e => setUnavailableDate(e.target.value)}
                                                            disabled={loading} required aria-describedby="unavailable-date-help" />
                                                        <Form.Text id="unavailable-date-help">This records your unavailability for this date. It does not book an inspection.</Form.Text>
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Reason for unavailability</Form.Label>
                                                        <Form.Select value={unavailableReason} onChange={e => setUnavailableReason(e.target.value)} disabled={loading} required={notAvailable}>
                                                            <option value="">Select a reason</option>
                                                            <option value="holiday">Away on holiday</option>
                                                            <option value="work">Work commitments</option>
                                                            <option value="illness">Illness / medical reasons</option>
                                                            <option value="no_access">Unable to provide access</option>
                                                            <option value="other">Other</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>Additional details {unavailableReason === 'other' ? '(required)' : '(optional)'}</Form.Label>
                                                        <Form.Control as="textarea" rows={3} maxLength={1000} value={unavailableDetails} onChange={e => setUnavailableDetails(e.target.value)} placeholder="Any dates you are away or other relevant details" disabled={loading} required={notAvailable && unavailableReason === 'other'} />
                                                    </Form.Group>
                                                </div>
                                            )}
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Group>
                                                <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '12px' }}>
                                                    <FontAwesomeIcon icon={faUser} className="label-icon" />
                                                    Booking Type
                                                </Form.Label>
                                                <Row className="g-3">
                                                    <Col xs={12} md={6}>
                                                        <div
                                                            onClick={() => setBookingType("tenant")}
                                                            style={{
                                                                padding: '12px 16px',
                                                                border: bookingType === "tenant"
                                                                    ? '2px solid #0d6efd'
                                                                    : '2px solid #dee2e6',
                                                                borderRadius: '8px',
                                                                cursor: 'pointer',
                                                                backgroundColor:
                                                                    bookingType === "tenant" ? '#f0f7ff' : '#fff',
                                                                transition: 'all 0.2s ease',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                height: '100%'
                                                            }}
                                                        >
                                                            <Form.Check
                                                                type="radio"
                                                                id="booking-tenant"
                                                                name="bookingType"
                                                                checked={bookingType === "tenant"}
                                                                onChange={() => setBookingType("tenant")}
                                                                onClick={(e) => e.stopPropagation()}
                                                                style={{
                                                                    pointerEvents: 'none',
                                                                    flexShrink: 0
                                                                }}
                                                            />

                                                            <label
                                                                htmlFor="booking-tenant"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    margin: 0,
                                                                    userSelect: 'none',
                                                                    fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)'
                                                                }}
                                                            >
                                                                <strong>Tenant / Leaseholder</strong>
                                                                <br />
                                                                <small className="text-muted">
                                                                    I live at this property
                                                                </small>
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xs={12} md={6}>
                                                        <div
                                                            onClick={() => setBookingType("landlord")}
                                                            style={{
                                                                padding: '12px 16px',
                                                                border: bookingType === "landlord"
                                                                    ? '2px solid #0d6efd'
                                                                    : '2px solid #dee2e6',
                                                                borderRadius: '8px',
                                                                cursor: 'pointer',
                                                                backgroundColor:
                                                                    bookingType === "landlord" ? '#f0f7ff' : '#fff',
                                                                transition: 'all 0.2s ease',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                height: '100%'
                                                            }}
                                                        >
                                                            <Form.Check
                                                                type="radio"
                                                                id="booking-landlord"
                                                                name="bookingType"
                                                                checked={bookingType === "landlord"}
                                                                onChange={() => setBookingType("landlord")}
                                                                onClick={(e) => e.stopPropagation()}
                                                                style={{
                                                                    pointerEvents: 'none',
                                                                    flexShrink: 0
                                                                }}
                                                            />

                                                            <label
                                                                htmlFor="booking-landlord"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    margin: 0,
                                                                    userSelect: 'none',
                                                                    fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)'
                                                                }}
                                                            >
                                                                <strong>Landlord / Agent</strong>
                                                                <br />
                                                                <small className="text-muted">
                                                                    Booking on behalf of tenant
                                                                </small>
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="g-3">
                                        <Col xs={12} md={6}>
                                            <Form.Group>
                                                <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                    <FontAwesomeIcon icon={faBuilding} className="label-icon" />
                                                    Building Name
                                                </Form.Label>
                                                <Select
                                                    options={options}
                                                    value={options.find(o => o.value === buildingName) || null}
                                                    onChange={handleBuildingChange}
                                                    isDisabled={loading}
                                                    placeholder="Select or type building"
                                                    isSearchable
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={selectStyles}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} md={6}>
                                            <Form.Group>
                                                <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                    <FontAwesomeIcon icon={faDoorClosed} className="label-icon" />
                                                    Flat Number
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="e.g., 101"
                                                    value={flatNo}
                                                    onChange={handleFlatNoChange}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
                                                        if (allowedKeys.includes(e.key)) return;

                                                        if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) return;

                                                        if (!/^[a-zA-Z0-9]$/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    className="form-input-custom"
                                                    disabled={loading || !buildingName}
                                                    style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} md={6}>
                                            <Form.Group>
                                                <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                    <FontAwesomeIcon icon={faEnvelope} className="label-icon" />
                                                    Email Address
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="e.g., user@example.com"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    className="form-input-custom"
                                                    disabled={loading || !buildingName}
                                                    style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} md={6}>
                                            <Form.Group>
                                                <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                    <FontAwesomeIcon icon={faPhone} className="label-icon" />
                                                    Phone Number
                                                </Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    placeholder="e.g., +44 7700 900123"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    className="form-input-custom"
                                                    disabled={loading || !buildingName}
                                                    style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}
                                                />
                                            </Form.Group>
                                        </Col>

                                        {bookingType === "landlord" && (
                                            <>
                                                <Col xs={12} md={6}>
                                                    <Form.Group>
                                                        <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                            <FontAwesomeIcon icon={faEnvelope} className="label-icon" />
                                                            Tenant Email
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            value={tenantEmail}
                                                            onChange={(e) => setTenantEmail(e.target.value)}
                                                            placeholder="e.g., tenant@example.com"
                                                            className="form-input-custom"
                                                            disabled={loading || !buildingName}
                                                            style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <Form.Group>
                                                        <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                            <FontAwesomeIcon icon={faPhone} className="label-icon" />
                                                            Tenant Phone
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="tel"
                                                            value={tenantPhone}
                                                            onChange={(e) => setTenantPhone(e.target.value)}
                                                            placeholder="e.g., +44 7700 900123"
                                                            className="form-input-custom"
                                                            disabled={loading || !buildingName}
                                                            style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        )}

                                        {!notAvailable && (<>
                                            <Col xs={12} md={6}>
                                                <Form.Group>
                                                    <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                        <FontAwesomeIcon icon={faCalendarDay} className="label-icon" />
                                                        First Preferred Date
                                                    </Form.Label>
                                                    <Form.Select
                                                        value={selectedDate}
                                                        onChange={(e) => setSelectedDate(e.target.value)}
                                                        className="form-input-custom"
                                                        disabled={loading || !buildingName}
                                                        style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}
                                                    >
                                                        <option value="">Select Date</option>
                                                        {getAvailableDates().map((date) => (
                                                            <option key={date} value={date}>
                                                                {date}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col xs={12} md={6}>
                                                <Form.Group>
                                                    <Form.Label className="form-label-custom" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)', marginBottom: '8px' }}>
                                                        <FontAwesomeIcon icon={faClock} className="label-icon" />
                                                        First Preferred Time
                                                    </Form.Label>
                                                    <Form.Select
                                                        value={selectedTimeSlot}
                                                        onChange={(e) => setSelectedTimeSlot(e.target.value)}
                                                        className="form-input-custom"
                                                        disabled={loading || !selectedDate}
                                                        style={{ fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)' }}
                                                    >
                                                        <option value="">Select Time Slot</option>
                                                        {getAvailableTimeSlots().map((slot) => {
                                                            const bookedCount = slotCounts[slot.uid] || 0;
                                                            const maxCapacity = slot.maxCapacity || 8;
                                                            const isFull = bookedCount >= maxCapacity;
                                                            const remaining = maxCapacity - bookedCount;
                                                            const slotValue = `${slot.uid}|${slot.startTime}|${slot.endTime}`;

                                                            return (
                                                                <option
                                                                    key={slot.uid}
                                                                    value={slot.uid}
                                                                    disabled={isFull}
                                                                >
                                                                    {slot.display} - {isFull ? 'FULLY RESERVED' : `${remaining} slot${remaining !== 1 ? 's' : ''} available`}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>


                                        </>)}

                                        {/* <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="form-label-custom">
                                                <FontAwesomeIcon icon={faCalendarDay} className="label-icon" />
                                                Second Preferred Date (Optional)
                                            </Form.Label>
                                            <Form.Select
                                                value={selectedSecondDate}
                                                onChange={(e) => setSelectedSecondDate(e.target.value)}
                                                className="form-input-custom"
                                                disabled={loading || !buildingName}
                                            >
                                                <option value="">Select Date</option>
                                                {getAvailableDates().map((date) => (
                                                    <option key={date} value={date}>
                                                        {date}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="form-label-custom">
                                                <FontAwesomeIcon icon={faClock} className="label-icon" />
                                                Second Preferred Time (Optional)
                                            </Form.Label>
                                          <Form.Select
                                                value={selectedSecondTimeSlot}
                                                onChange={(e) => setSelectedSecondTimeSlot(e.target.value)}
                                                className="form-input-custom"
                                                disabled={loading || !selectedSecondDate}
                                            >
                                                <option value="">Select Time Slot</option>
                                                {selectedSecondDate && getAvailableTimeSlotsForSecond().map((slot) => {
                                                    const bookedCount = slotCounts[slot.uid] || 0;
                                                    const isFull = bookedCount >= 8;
                                                    const remaining = 8 - bookedCount;
                                                    const slotValue = `${slot.uid}|${slot.startTime}|${slot.endTime}`;
                                                    
                                                    return (
                                                        <option 
                                                            key={`${slot.uid}_${slot.startTime}`} 
                                                            value={slotValue}
                                                            disabled={isFull}
                                                            style={isFull ? { color: '#999' } : {}}
                                                        >
                                                            {slot.display} - {isFull ? 'FULLY RESERVED' : `${remaining} slot${remaining !== 1 ? 's' : ''} available`}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row> */}
                                        {/* <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="form-label-custom">
                                            <FontAwesomeIcon icon={faCalendarDay} className="label-icon" />
                                            Second Preferred Date & Time
                                        </Form.Label>
                                        <Form.Select
                                            value={secondDate}
                                            onChange={(e) => setSecondDate(e.target.value)}
                                            className="form-input-custom"
                                            disabled={loading || !buildingName || (buildingName === "Russell Court" && !flatFloor)}
                                        >
                                            <option value="">
                                                {buildingName === "Russell Court" && !flatNo.trim()
                                                    ? "Enter flat number first"
                                                    : buildingName === "Russell Court" && !flatFloor
                                                        ? "Invalid flat number"
                                                        : "Select Time Slot"}
                                            </option>
                                            {getAvailableSlots()
                                                .filter(slot => slot.value !== firstDate)
                                                .map((slot) => (
                                                    <option key={slot.value} value={slot.value}>
                                                        {slot.display}
                                                    </option>
                                                ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col> */}

                                        <Col xs={12} md={6}>
                                            <Form.Group>
                                                {/* <div
                                                    onClick={() => {
                                                        if (loading) return;
                                                        const nextValue = !keyGivenToManager;
                                                        setKeyGivenToManager(nextValue);
                                                        if (!nextValue) setKeyDetails("");
                                                    }}
                                                    className="d-flex align-items-center flex-wrap gap-2 py-2"
                                                    style={{
                                                        cursor: loading ? 'not-allowed' : 'pointer',
                                                        userSelect: 'none',
                                                        fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: 20,
                                                            height: 20,
                                                            minWidth: 20,
                                                            border: '2px solid #dc3545',
                                                            borderRadius: 4,
                                                            backgroundColor: keyGivenToManager ? '#dc3545' : 'transparent',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        {keyGivenToManager && (
                                                            <span style={{ color: '#fff', fontSize: 14, lineHeight: 1 }}>
                                                                ✓
                                                            </span>
                                                        )}
                                                    </div>

                                                    <FontAwesomeIcon icon={faKey} />

                                                    <span style={{ flex: 1 }}>
                                                        I give permission for use of my keys
                                                    </span>
                                                </div> */}

                                                {!notAvailable && keyGivenToManager && (
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        value={keyDetails}
                                                        onChange={(e) => setKeyDetails(e.target.value)}
                                                        placeholder="Please tell us where the keys can be found or who they have been left with"
                                                        disabled={loading}
                                                        required={keyGivenToManager}
                                                        className="form-input-custom"
                                                        style={{
                                                            resize: 'none',
                                                            height: '60px',
                                                            minHeight: '60px'
                                                        }}
                                                    />
                                                )}
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} md={6}>
                                            <Form.Group>
                                                <div
                                                    onClick={() => !loading && setAgreedToTerms(!agreedToTerms)}
                                                    className="d-flex align-items-center flex-wrap gap-2 py-2"
                                                    style={{
                                                        cursor: loading ? 'not-allowed' : 'pointer',
                                                        userSelect: 'none',
                                                        fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: 20,
                                                            height: 20,
                                                            minWidth: 20,
                                                            border: '2px solid #dc3545',
                                                            borderRadius: 4,
                                                            backgroundColor: agreedToTerms ? '#dc3545' : 'transparent',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        {agreedToTerms && (
                                                            <span style={{ color: '#fff', fontSize: 14, lineHeight: 1 }}>
                                                                ✓
                                                            </span>
                                                        )}
                                                    </div>

                                                    <span style={{ flex: 1 }}>
                                                        I agree to the{' '}
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setShowTermsModal(true);
                                                            }}
                                                            style={{
                                                                color: '#dc3545',
                                                                textDecoration: 'underline',
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            Terms and Conditions
                                                        </a>
                                                    </span>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                    </Row>

                                    <div className="button-wrapper">
                                        <Button
                                            type="submit"
                                            variant="danger"
                                            className="btn-submit-inspection"
                                            disabled={loading || submitted}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                    Submitting...
                                                </>
                                            ) : submitted ? (
                                                <>
                                                    <FontAwesomeIcon icon={faClipboardCheck} className="me-2" />
                                                    Submitted!
                                                </>
                                            ) : (
                                                <>
                                                    <FontAwesomeIcon icon={faClipboardCheck} className="me-2" />
                                                    {notAvailable ? "Submit Unavailability" : "Submit Request"}
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </>
                )}

                {activeTab === 'unavailable' && ['admin', 'manager', 'inspection', 'coordinator'].includes(userData.role) && (
                    <div style={{ width: '100%', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            flexWrap: 'wrap',
                            gap: '12px'
                        }}>
                            <div>
                                <h4 style={{ margin: 0, fontWeight: 700, color: '#0f172a', fontSize: '1.25rem' }}>
                                    Not Available
                                </h4>
                                <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: '0.85rem' }}>
                                    {filteredUnavailableResponses.length} response{filteredUnavailableResponses.length !== 1 ? 's' : ''} total
                                    {unavailableBuildingFilter !== 'all' && (
                                        <span> in <strong>{unavailableBuildingFilter}</strong></span>
                                    )}
                                </p>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '10px',
                                    overflowX: 'auto',
                                    flexWrap: 'nowrap',
                                    WebkitOverflowScrolling: 'touch',
                                    alignItems: 'center'
                                }}
                            >
                                {(unavailableDateFilter !== 'future' || unavailableBuildingFilter !== 'all') && (
                                    <button
                                        onClick={() => {
                                            setUnavailableDateFilter('future');
                                            setUnavailableBuildingFilter('all');
                                        }}
                                        style={{
                                            flex: '0 0 140px',
                                            textAlign: 'center',
                                            backgroundColor: '#fff',
                                            border: '1px solid #d1d5db',
                                            color: '#6b7280',
                                            padding: '8px 10px',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            fontSize: '0.8rem',
                                            fontWeight: 500,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '4px',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f9fafb';
                                            e.currentTarget.style.borderColor = '#9ca3af';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#fff';
                                            e.currentTarget.style.borderColor = '#d1d5db';
                                        }}
                                    >
                                        ✕ Clear
                                    </button>
                                )}

                                <select
                                    aria-label="Filter unavailable responses by date"
                                    value={unavailableDateFilter}
                                    onChange={(e) => setUnavailableDateFilter(e.target.value)}
                                    style={{
                                        flex: '0 0 140px',
                                        textAlign: 'left',
                                        direction: 'ltr',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#fff',
                                        fontSize: '0.85rem',
                                        color: '#374151',
                                        fontWeight: 500,
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    <option value="future">Upcoming</option>
                                    <option value="past">Past</option>
                                    <option value="all">All Dates</option>
                                </select>

                                <select
                                    aria-label="Filter unavailable responses by building"
                                    value={unavailableBuildingFilter}
                                    onChange={(e) => setUnavailableBuildingFilter(e.target.value)}
                                    style={{
                                        flex: '0 0 auto',
                                        width: '160px',
                                        minWidth: '160px',
                                        textAlign: 'left',
                                        direction: 'ltr',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#fff',
                                        fontSize: '0.85rem',
                                        color: '#374151',
                                        fontWeight: 500,
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    <option value="all">All Buildings</option>
                                    {unavailableBuildings.map(building => (
                                        <option key={building} value={building}>
                                            {building}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    onClick={exportUnavailableToExcel}
                                    style={{
                                        flex: '0 0 140px',
                                        textAlign: 'center',
                                        backgroundColor: '#fff',
                                        border: '1px solid #d1d5db',
                                        color: '#374151',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '0.85rem',
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                    </svg>
                                    Export Excel
                                </button>

                                <button
                                    onClick={fetchUnavailableResponses}
                                    disabled={unavailableLoading}
                                    style={{
                                        flex: '0 0 140px',
                                        textAlign: 'center',
                                        backgroundColor: '#fff',
                                        border: '1px solid #d1d5db',
                                        color: '#374151',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '0.85rem',
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    ↻ Refresh
                                </button>
                            </div>
                        </div>

                        <p style={{ color: '#64748b', fontSize: '0.8rem', marginBottom: '16px' }}>Upcoming includes today. Responses without a date appear under All Dates.</p>
                        {unavailableError && <p role="alert" className="text-danger">{unavailableError}</p>}
                        {unavailableLoading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border" style={{ color: '#3b82f6', width: '2.5rem', height: '2.5rem' }} role="status" aria-label="Loading unavailable responses" />
                                <p className="mt-3" style={{ color: '#6b7280' }}>Loading responses...</p>
                            </div>
                        ) : filteredUnavailableResponses.length === 0 ? (
                            <div className="text-center py-5">
                                <div style={{ fontSize: '48px', marginBottom: '12px' }}>📭</div>
                                <p style={{ color: '#9ca3af', fontSize: '0.95rem' }}>No unavailability responses match these filters.</p>
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto', borderRadius: '12px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                <table className="table align-middle mb-0" style={{ fontSize: '0.84rem', minWidth: '1400px' }}>
                                    <thead style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                        <tr>{['#', 'Building', 'Flat', 'Unavailable Date', 'Email', 'Phone', 'Submitted By', 'Tenant Email', 'Tenant Phone', 'Reason', 'Details', 'Status', 'Submitted At'].map(label => (
                                            <th key={label} scope="col" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px', whiteSpace: 'nowrap' }}>{label}</th>
                                        ))}</tr>
                                    </thead>
                                    <tbody>{filteredUnavailableResponses.map((response, index) => {
                                        const cellStyle = { padding: '12px 16px', backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f1f1', borderTop: '1px solid #f3f4f6' };
                                        return (
                                            <tr key={`${response.buildingId}-${response.id}`}>
                                                <td style={{ ...cellStyle, color: '#94a3b8', fontWeight: 600 }}>{String(index + 1).padStart(2, '0')}</td>
                                                <td style={{ ...cellStyle, fontWeight: 600, color: '#111827' }}>{response.buildingName || '—'}</td>
                                                <td style={cellStyle}>{response.flatNo || '—'}</td>
                                                <td style={{ ...cellStyle, fontWeight: 500, whiteSpace: 'nowrap' }}>{isValidDateKey(response.unavailableDate) ? response.unavailableDate.split('-').reverse().join('/') : 'Not specified'}</td>
                                                <td style={cellStyle}>{response.email || '—'}</td>
                                                <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>{response.phone || '—'}</td>
                                                <td style={{ ...cellStyle, textTransform: 'capitalize' }}>{response.bookingType || '—'}</td>
                                                <td style={cellStyle}>{response.tenantEmail || '—'}</td>
                                                <td style={cellStyle}>{response.tenantPhone || '—'}</td>
                                                <td style={cellStyle}>{unavailableReasonLabel(response.reason)}</td>
                                                <td style={{ ...cellStyle, minWidth: 220, maxWidth: 360, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{response.details || '—'}</td>
                                                <td style={cellStyle}><span style={{ backgroundColor: '#fef2f2', color: '#dc2626', padding: '4px 10px', borderRadius: '12px', fontSize: '0.7rem', fontWeight: 700, whiteSpace: 'nowrap' }}>Not Available</span></td>
                                                <td style={{ ...cellStyle, whiteSpace: 'nowrap', color: '#64748b' }}>{response.submittedAt?.toDate?.().toLocaleString('en-GB') || '—'}</td>
                                            </tr>
                                        );
                                    })}</tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'view' && (userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator') && (
                    <div style={{ width: '100%', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            flexWrap: 'wrap',
                            gap: '12px'
                        }}>
                            <div>
                                <h4 style={{ margin: 0, fontWeight: 700, color: '#0f172a', fontSize: '1.25rem' }}>
                                    All Bookings
                                </h4>
                                <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: '0.85rem' }}>
                                    {filteredBookings.length} booking{filteredBookings.length !== 1 ? 's' : ''} total
                                    {buildingFilter !== 'all' && (
                                        <span> in <strong>{buildingFilter}</strong></span>
                                    )}
                                </p>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '10px',
                                    overflowX: 'auto',
                                    flexWrap: 'nowrap',
                                    WebkitOverflowScrolling: 'touch',
                                    alignItems: 'center'
                                }}
                            >
                                {(dateFilter !== 'future' || buildingFilter !== 'all') && (
                                    <button
                                        onClick={() => {
                                            setDateFilter('future');
                                            setBuildingFilter('all');
                                        }}
                                        style={{
                                            flex: '0 0 140px',
                                            textAlign: 'center',
                                            backgroundColor: '#fff',
                                            border: '1px solid #d1d5db',
                                            color: '#6b7280',
                                            padding: '8px 10px',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            fontSize: '0.8rem',
                                            fontWeight: 500,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '4px',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f9fafb';
                                            e.currentTarget.style.borderColor = '#9ca3af';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#fff';
                                            e.currentTarget.style.borderColor = '#d1d5db';
                                        }}
                                    >
                                        ✕ Clear
                                    </button>
                                )}

                                <select
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                    style={{
                                        flex: '0 0 140px',
                                        textAlign: 'left',
                                        direction: 'ltr',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#fff',
                                        fontSize: '0.85rem',
                                        color: '#374151',
                                        fontWeight: 500,
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    <option value="future">Upcoming</option>
                                    <option value="past">Past</option>
                                    <option value="all">All Dates</option>
                                </select>

                                <select
                                    value={buildingFilter}
                                    onChange={(e) => setBuildingFilter(e.target.value)}
                                    style={{
                                        flex: '0 0 auto',
                                        width: '160px',
                                        minWidth: '160px',
                                        textAlign: 'left',
                                        direction: 'ltr',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#fff',
                                        fontSize: '0.85rem',
                                        color: '#374151',
                                        fontWeight: 500,
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    <option value="all">All Buildings</option>
                                    {uniqueBuildings.map(building => (
                                        <option key={building} value={building}>
                                            {building}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    onClick={exportToExcel}
                                    style={{
                                        flex: '0 0 140px',
                                        textAlign: 'center',
                                        backgroundColor: '#fff',
                                        border: '1px solid #d1d5db',
                                        color: '#374151',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '0.85rem',
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                    </svg>
                                    Export Excel
                                </button>

                                <button
                                    onClick={fetchAllBookings}
                                    style={{
                                        flex: '0 0 140px',
                                        textAlign: 'center',
                                        backgroundColor: '#fff',
                                        border: '1px solid #d1d5db',
                                        color: '#374151',
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '0.85rem',
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                        e.currentTarget.style.borderColor = '#9ca3af';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#fff';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    ↻ Refresh
                                </button>
                            </div>
                        </div>

                        {bookingsLoading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border" style={{ color: '#3b82f6', width: '2.5rem', height: '2.5rem' }} role="status" />
                                <p className="mt-3" style={{ color: '#6b7280' }}>Loading bookings...</p>
                            </div>
                        ) : filteredBookings.length === 0 ? (
                            <div className="text-center py-5">
                                <div style={{ fontSize: '48px', marginBottom: '12px' }}>📭</div>
                                <p style={{ color: '#9ca3af', fontSize: '0.95rem' }}>No bookings found.</p>
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto', borderRadius: '12px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                <table className="table align-middle mb-0" style={{ fontSize: '0.84rem', minWidth: '1400px' }}>                                    <thead style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                    <tr>
                                        <th className="text-center" style={{ width: '40px', fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>#</th>
                                        <th style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Building</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Flat</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Date</th>
                                        <th style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Time Slot</th>
                                        <th style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Email</th>
                                        <th style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Phone</th>
                                        <th className="text-center" style={{ width: '90px', fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 16px' }}>Landlord</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Tenant Email</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Tenant Phone</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Keys</th>
                                        <th style={{ minWidth: '220px', fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Key Details</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Terms</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Status</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Email Sent</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Submitted At</th>
                                        <th className="text-center" style={{ fontWeight: 600, fontSize: '0.73rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b', padding: '14px 12px' }}>Action</th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        {(() => {
                                            let rowNumber = 0;
                                            const groups = getGroupedBookings();
                                            return groups.map((group, groupIdx) => {
                                                const groupBgColor = groupIdx % 2 === 0 ? '#ffffff' : '#f1f1f1';
                                                return group.bookings.map((booking, idx) => {
                                                    rowNumber++;
                                                    const s = (val) => {
                                                        if (val === null || val === undefined) return '';
                                                        if (typeof val === 'string') return val;
                                                        if (val.seconds) return new Date(val.seconds * 1000).toLocaleString('en-GB');
                                                        return String(val);
                                                    };

                                                    const dateStr = (() => {
                                                        try { return s(booking.firstDate || booking.date); } catch (e) { return ''; }
                                                    })();

                                                    const firstDateFrom = s(booking.firstDate_from);
                                                    const firstDateTo = s(booking.firstDate_to);
                                                    const secondDateFrom = s(booking.secondDate_from);
                                                    const secondDateTo = s(booking.secondDate_to);

                                                    const created = (() => {
                                                        const c = booking.createdAt || booking.submittedAt;
                                                        if (!c) return '';
                                                        if (c.seconds) return new Date(c.seconds * 1000).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
                                                        return s(c);
                                                    })();

                                                    const isConfirmed = !!booking.firstSlotUid;
                                                    const emailSent = booking.emailSent === true || booking.emailSent === 'yes';
                                                    const isResending = resendingIds.has(booking.id);

                                                    const handleResendEmail = async () => {
                                                        try {
                                                            setResendingIds(prev => new Set(prev).add(booking.id));

                                                            const { doc, updateDoc } = await import('firebase/firestore');
                                                            const bookingRef = doc(db, 'inspections', booking.buildingId, 'dates', booking.date, 'bookings', booking.id);
                                                            await updateDoc(bookingRef, { resendRequested: true });

                                                            setTimeout(() => {
                                                                setResendingIds(prev => {
                                                                    const next = new Set(prev);
                                                                    next.delete(booking.id);
                                                                    return next;
                                                                });
                                                            }, 2000);
                                                        } catch (err) {
                                                            console.error('Failed to resend email:', err);
                                                            setResendingIds(prev => {
                                                                const next = new Set(prev);
                                                                next.delete(booking.id);
                                                                return next;
                                                            });
                                                        }
                                                    };

                                                    const isFirstInGroup = idx === 0;
                                                    const totalSlotsTaken = group.bookings.length;
                                                    const slotsRemaining = 8 - totalSlotsTaken;
                                                    const isFull = slotsRemaining <= 0;

                                                    return (
                                                        <tr
                                                            key={booking.id}
                                                            data-group={groupIdx}
                                                            style={{ backgroundColor: groupBgColor }}
                                                        >
                                                            <td className="text-center" style={{ color: '#94a3b8', fontWeight: 600, fontSize: '0.8rem', padding: '12px 16px', backgroundColor: groupBgColor }}>
                                                                {String(rowNumber).padStart(2, '0')}
                                                            </td>
                                                            <td style={{ fontWeight: 600, color: '#111827', padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    {isFirstInGroup ? (
                                                                        <span style={{
                                                                            backgroundColor: isFull ? '#fef2f2' : '#f0fdf4',
                                                                            color: isFull ? '#dc2626' : '#16a34a',
                                                                            padding: '3px 8px',
                                                                            borderRadius: '12px',
                                                                            fontSize: '0.7rem',
                                                                            fontWeight: 700,
                                                                            flexShrink: 0
                                                                        }}>
                                                                            {isFull ? 'FULL' : `${slotsRemaining} left`}
                                                                        </span>
                                                                    ) : (
                                                                        <span style={{
                                                                            backgroundColor: '#f9fafb',
                                                                            color: '#9ca3af',
                                                                            padding: '3px 8px',
                                                                            borderRadius: '12px',
                                                                            fontSize: '0.7rem',
                                                                            fontWeight: 700,
                                                                            flexShrink: 0,
                                                                            border: '1px solid #e5e7eb'
                                                                        }}>
                                                                            {isFull ? 'FULL' : `${slotsRemaining} left`}
                                                                        </span>
                                                                    )}
                                                                    <span>{s(booking.buildingName) || '—'}</span>
                                                                </div>
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {s(booking.flatNo) || <span style={{ color: '#cbd5e1' }}>—</span>}
                                                            </td>
                                                            <td className="text-center" style={{ fontWeight: 500, padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {dateStr || '—'}
                                                            </td>
                                                            <td style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {firstDateFrom ? (
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                                        <span style={{
                                                                            display: 'inline-block',
                                                                            backgroundColor: isFull ? '#fef2f2' : '#ecfdf5',
                                                                            color: isFull ? '#dc2626' : '#065f46',
                                                                            padding: '4px 10px',
                                                                            borderRadius: '6px',
                                                                            fontSize: '0.8rem',
                                                                            fontWeight: 500
                                                                        }}>
                                                                            {firstDateFrom} - {firstDateTo || '?'}
                                                                        </span>
                                                                        {secondDateFrom && (
                                                                            <span style={{
                                                                                display: 'inline-block',
                                                                                backgroundColor: '#eef2ff',
                                                                                color: '#3730a3',
                                                                                padding: '4px 10px',
                                                                                borderRadius: '6px',
                                                                                fontSize: '0.78rem',
                                                                                fontWeight: 500
                                                                            }}>
                                                                                2nd: {secondDateFrom} - {secondDateTo || '?'}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <span style={{ color: '#cbd5e1' }}>—</span>
                                                                )}
                                                            </td>
                                                            <td style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {s(booking.email) ? (
                                                                    <a href={`mailto:${booking.email}`} style={{ color: '#3b82f6', fontWeight: 500, textDecoration: 'none' }}>
                                                                        {s(booking.email)}
                                                                    </a>
                                                                ) : <span style={{ color: '#cbd5e1' }}>—</span>}
                                                            </td>
                                                            <td style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {s(booking.phone) || <span style={{ color: '#cbd5e1' }}>—</span>}
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {(s(booking.tenantEmail) || s(booking.tenantPhone)) ? (
                                                                    <span className="badge" style={{
                                                                        backgroundColor: '#f5f3ff',
                                                                        color: '#7c3aed',
                                                                        fontWeight: 600,
                                                                        fontSize: '0.73rem',
                                                                        padding: '6px 12px',
                                                                        borderRadius: '20px'
                                                                    }}>
                                                                        Yes
                                                                    </span>
                                                                ) : (
                                                                    <span className="badge" style={{
                                                                        backgroundColor: '#f3f4f6',
                                                                        color: '#6b7280',
                                                                        fontWeight: 600,
                                                                        fontSize: '0.73rem',
                                                                        padding: '6px 12px',
                                                                        borderRadius: '20px'
                                                                    }}>
                                                                        No
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {s(booking.tenantEmail) ? (
                                                                    <a href={`mailto:${booking.tenantEmail}`} style={{ color: '#8b5cf6', fontWeight: 500, textDecoration: 'none', fontSize: '0.8rem' }}>
                                                                        {s(booking.tenantEmail)}
                                                                    </a>
                                                                ) : <span style={{ color: '#cbd5e1' }}>—</span>}
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {s(booking.tenantPhone) || <span style={{ color: '#cbd5e1' }}>—</span>}
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                <span style={{
                                                                    color: booking.keyGivenToManager ? '#059669' : '#dc2626',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.8rem'
                                                                }}>
                                                                    {booking.keyGivenToManager ? '✓' : '✗'}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6', fontSize: '0.8rem', maxWidth: '280px', whiteSpace: 'normal' }}>
                                                                {booking.keyGivenToManager && s(booking.keyDetails)
                                                                    ? s(booking.keyDetails)
                                                                    : <span style={{ color: '#cbd5e1' }}>—</span>}
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                <span style={{
                                                                    color: booking.agreedToTerms ? '#059669' : '#dc2626',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.8rem'
                                                                }}>
                                                                    {booking.agreedToTerms ? '✓' : '✗'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                <span className="badge" style={{
                                                                    backgroundColor: isConfirmed ? '#ecfdf5' : '#fffbeb',
                                                                    color: isConfirmed ? '#065f46' : '#92400e',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.73rem',
                                                                    padding: '6px 12px',
                                                                    borderRadius: '20px'
                                                                }}>
                                                                    {isConfirmed ? 'Confirmed' : 'Pending'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center" style={{ padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                <span className="badge" style={{
                                                                    backgroundColor: emailSent ? '#ecfdf5' : '#fef2f2',
                                                                    color: emailSent ? '#065f46' : '#991b1b',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.73rem',
                                                                    padding: '6px 12px',
                                                                    borderRadius: '20px'
                                                                }}>
                                                                    {emailSent ? 'Yes' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center" style={{ fontSize: '0.78rem', color: '#6b7280', padding: '12px 16px', backgroundColor: groupBgColor, borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6' }}>
                                                                {created || '—'}
                                                            </td>
                                                            <td
                                                                className="text-center"
                                                                style={{
                                                                    padding: '12px 16px',
                                                                    backgroundColor: groupBgColor,
                                                                    borderTop: isFirstInGroup && groupIdx > 0 ? '2px solid #cbd5e1' : '1px solid #f3f4f6'
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                                                    <button
                                                                        onClick={handleResendEmail}
                                                                        disabled={isResending}
                                                                        style={{
                                                                            backgroundColor: isResending ? '#ecfdf5' : '#f9fafb',
                                                                            border: isResending ? '1px solid #bbf7d0' : '1px solid #e5e7eb',
                                                                            color: isResending ? '#16a34a' : '#374151',
                                                                            padding: '5px 14px',
                                                                            borderRadius: '6px',
                                                                            cursor: isResending ? 'default' : 'pointer',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            transition: 'all 0.15s ease',
                                                                            opacity: isResending ? 0.8 : 1
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            if (!isResending) e.currentTarget.style.backgroundColor = '#f3f4f6';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            if (!isResending) e.currentTarget.style.backgroundColor = '#f9fafb';
                                                                        }}
                                                                    >
                                                                        {isResending ? 'Sending...' : 'Resend'}
                                                                    </button>
                                                                    <button
                                                                        onClick={() => {
                                                                            setBookingToDelete(booking);
                                                                            setShowDeleteModal(true);
                                                                        }}
                                                                        style={{
                                                                            backgroundColor: '#fff',
                                                                            border: '1px solid #fecaca',
                                                                            color: '#dc2626',
                                                                            padding: '5px 14px',
                                                                            borderRadius: '6px',
                                                                            cursor: 'pointer',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            transition: 'all 0.15s ease'
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.backgroundColor = '#fef2f2';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.backgroundColor = '#fff';
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </button>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    );
                                                });
                                            });
                                        })()}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}

            </div >

            <Modal
                isOpen={showDeleteModal}
                onRequestClose={() => {
                    if (!deleting) {
                        setShowDeleteModal(false);
                        setBookingToDelete(null);
                    }
                }}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    content: {
                        position: 'relative',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        maxWidth: '450px',
                        width: '90%',
                        padding: '0',
                        borderRadius: '12px',
                        border: 'none',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        overflow: 'visible'
                    }
                }}
                contentLabel="Delete Booking Confirmation"
            >
                <div style={{ padding: '24px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            backgroundColor: '#fef2f2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px'
                        }}>
                            <FontAwesomeIcon icon={faTrash} style={{ color: '#dc2626', fontSize: '20px' }} />
                        </div>
                        <h5 style={{ margin: '0 0 8px', fontWeight: 600, color: '#111827' }}>
                            Delete Booking
                        </h5>
                        <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>
                            Are you sure you want to delete this booking{bookingToDelete ? ` for Flat ${bookingToDelete.flatNo} at ${bookingToDelete.buildingName}` : ''}? This action cannot be undone.
                        </p>
                    </div>

                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                        <button
                            onClick={() => {
                                setShowDeleteModal(false);
                                setBookingToDelete(null);
                            }}
                            disabled={deleting}
                            style={{
                                padding: '10px 24px',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db',
                                backgroundColor: '#fff',
                                color: '#374151',
                                fontWeight: 600,
                                fontSize: '0.9rem',
                                cursor: deleting ? 'not-allowed' : 'pointer',
                                transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                                if (!deleting) {
                                    e.currentTarget.style.backgroundColor = '#f9fafb';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#fff';
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleDeleteBooking}
                            disabled={deleting}
                            style={{
                                padding: '10px 24px',
                                borderRadius: '8px',
                                border: 'none',
                                backgroundColor: '#dc2626',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '0.9rem',
                                cursor: deleting ? 'not-allowed' : 'pointer',
                                opacity: deleting ? 0.7 : 1,
                                transition: 'all 0.15s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                                if (!deleting) {
                                    e.currentTarget.style.backgroundColor = '#b91c1c';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#dc2626';
                            }}
                        >
                            {deleting ? (
                                <>
                                    <Spinner animation="border" size="sm" />
                                    Deleting...
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faTrash} />
                                    Delete Booking
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={showTermsModal}
                onRequestClose={() => setShowTermsModal(false)}
                style={termsModalStyles}
                contentLabel="Terms of Business"
                shouldCloseOnOverlayClick={true}
            >
                <div
                    style={{
                        borderBottom: '1px solid #dee2e6',
                        padding: '20px 24px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexShrink: 0,
                    }}
                >
                    <h5
                        style={{
                            margin: 0,
                            fontWeight: 600,
                        }}
                    >
                        FireChecked Limited – Terms of Business
                    </h5>

                    <button
                        onClick={() => setShowTermsModal(false)}
                        type="button"
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#6c757d',
                            padding: 0,
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </button>
                </div>

                <div
                    style={{
                        padding: '24px 32px 24px 30px',
                        overflowY: 'auto',
                        scrollbarGutter: 'stable',
                        flex: 1,
                        minHeight: 0,
                    }}
                >
                    <p
                        style={{
                            color: '#6c757d',
                            fontSize: '13px',
                            marginTop: 0,
                            marginBottom: '20px',
                        }}
                    >
                        Last updated: October 2026
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        These Terms &amp; Conditions outline the requirements for residents, leaseholders and tenants when FireChecked Limited (&quot;FireChecked&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;) undertakes fire door inspections or remedial works at their property.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        1. Booking and Access Arrangements
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Residents are responsible for ensuring that access to their property is available on their scheduled appointment date.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Where multiple inspection dates have been arranged for a building, <em>FireChecked will make reasonable efforts to attempt access during the first scheduled visit, even where a resident has booked an appointment for the second available date.</em>
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        If access is unsuccessful during the first visit, the resident's existing booking will remain in place.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        First-visit access attempts are subject to the availability of our inspection team and cannot be guaranteed.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Residents should notify FireChecked as soon as possible if they need to rearrange their appointment.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        2. Adult Supervision
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        <em>An adult aged 18 or over must be present at the property throughout the inspection or remedial works.</em>
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        This may be the resident, tenant, leaseholder or another authorised representative.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        FireChecked will not enter or undertake works at a property where only persons under 18 are present.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        3. Preparing for Your Appointment
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        To allow our team to work safely and efficiently, residents must ensure that:
                    </p>

                    <ul
                        style={{
                            fontSize: '14px',
                            fontWeight: 400,
                            color: '#212529',
                            lineHeight: '1.6',
                            margin: '0 0 16px 0',
                            paddingLeft: '22px',
                            listStyleType: 'disc',
                            listStylePosition: 'outside',
                        }}
                    >
                        <li style={{ marginBottom: '6px', paddingLeft: '2px', fontSize: '14px', fontWeight: 400, color: '#212529' }}>Both sides of the flat entrance door are accessible.</li>
                        <li style={{ marginBottom: '6px', paddingLeft: '2px', fontSize: '14px', fontWeight: 400, color: '#212529' }}>The immediate area surrounding the door is clear of furniture and personal belongings.</li>
                        <li style={{ marginBottom: '6px', paddingLeft: '2px', fontSize: '14px', fontWeight: 400, color: '#212529' }}>Pets are safely secured away from the working area.</li>
                        <li style={{ marginBottom: '6px', paddingLeft: '2px', fontSize: '14px', fontWeight: 400, color: '#212529' }}>Any known hazards, access restrictions or special requirements are communicated in advance.</li>
                        <li style={{ marginBottom: '6px', paddingLeft: '2px', fontSize: '14px', fontWeight: 400, color: '#212529' }}>Suitable lighting and safe working conditions are provided.</li>
                        <li style={{ marginBottom: '6px', paddingLeft: '2px', fontSize: '14px', fontWeight: 400, color: '#212529' }}>Any required permissions for the inspection or works have been obtained.</li>
                    </ul>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        FireChecked reserves the right to postpone an inspection or works where access is unsafe or the necessary conditions have not been met.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        4. Rented Properties
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Where a property is rented, the leaseholder or person arranging the appointment is responsible for informing the tenant and ensuring that suitable access arrangements are in place.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        FireChecked may communicate directly with tenants or managing agents where appropriate to facilitate access.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        5. Inspection Findings and Additional Works
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Fire door inspections assess the condition of the door assembly and its associated components at the time of inspection.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Any defects identified will be documented and, where necessary, reported to the relevant property manager or Responsible Person.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Some defects may only become apparent once remedial works have commenced. Any additional works outside the agreed scope will require appropriate authorisation before proceeding.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        6. Decoration and Finishes
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        FireChecked will take reasonable care to protect the property while carrying out remedial works.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        However, certain adjustments or repairs may disturb existing paintwork, sealant or decorative finishes.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Unless specifically agreed in advance, redecoration and making good of existing finishes are not included within the scope of works.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        This does not affect FireChecked's responsibility for damage caused by a failure to exercise reasonable care and skill.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        7. Delays and Rescheduling
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        FireChecked will make reasonable efforts to attend appointments on the agreed dates.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Occasionally, appointments may need to be rearranged due to unforeseen site conditions, safety concerns, material availability or operational requirements.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Where this occurs, FireChecked will communicate any changes and arrange an alternative appointment where appropriate.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        8. Photographs and Inspection Records
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        FireChecked may take photographs and record relevant information relating to the fire door, frame, components and identified defects.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        These records will be used for inspection reporting, quality assurance and fire safety management and may be shared with the relevant property manager, building owner or Responsible Person.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Reasonable efforts will be made to avoid recording unnecessary personal information.
                    </p>

                    <h6
                        style={{
                            fontWeight: 600,
                            marginTop: '20px',
                            marginBottom: '12px',
                        }}
                    >
                        9. Acceptance of Terms
                    </h6>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        By confirming an appointment, residents acknowledge the access, supervision and preparation requirements outlined in these Terms &amp; Conditions.
                    </p>

                    <p
                        style={{
                            fontSize: '14px',
                            lineHeight: '1.6',
                            marginBottom: '16px',
                        }}
                    >
                        Nothing in these Terms &amp; Conditions affects any applicable statutory rights.
                    </p>

                    <div
                        style={{
                            marginTop: '24px',
                            paddingTop: '20px',
                            borderTop: '1px solid #dee2e6',
                            fontSize: '13px',
                            color: '#6c757d',
                            lineHeight: '1.6',
                        }}
                    >
                        <p
                            style={{
                                fontWeight: 600,
                                marginBottom: '8px',
                                color: '#333',
                            }}
                        >
                            FireChecked Limited
                        </p>

                        <p style={{ margin: '4px 0' }}>
                            Registered in England and Wales
                            <br />
                            Company Number: 16308299
                        </p>

                        <p style={{ margin: '12px 0 4px 0' }}>
                            <strong>Registered Office:</strong>
                            <br />
                            Foundation House, 42-48 London Road, Reigate, Surrey RH2 9QQ
                        </p>

                        <p style={{ margin: '12px 0 4px 0' }}>
                            <strong>Email:</strong>{' '}
                            <a
                                href="mailto:inspections@firechecked.co.uk"
                                style={{
                                    color: '#dc3545',
                                    textDecoration: 'none',
                                }}
                            >
                                inspections@firechecked.co.uk
                            </a>
                            <br />

                            <strong>Telephone:</strong> 01483 338356
                            <br />

                            <strong>Website:</strong>{' '}
                            <a
                                href="https://www.firechecked.co.uk"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: '#dc3545',
                                    textDecoration: 'none',
                                }}
                            >
                                www.firechecked.co.uk
                            </a>
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        borderTop: '1px solid #dee2e6',
                        padding: '16px 24px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        flexShrink: 0,
                        background: '#fff',
                    }}
                >
                    <button
                        type="button"
                        onClick={() => setShowTermsModal(false)}
                        style={{
                            padding: '8px 20px',
                            borderRadius: '6px',
                            border: '1px solid #dee2e6',
                            background: '#fff',
                            color: '#7b7b7b',
                            cursor: 'pointer',
                            fontSize: '14px',
                        }}
                    >
                        Close
                    </button>

                    <button
                        type="button"
                        onClick={() => {
                            setAgreedToTerms(true);
                            setShowTermsModal(false);
                        }}
                        style={{
                            padding: '8px 20px',
                            borderRadius: '6px',
                            border: 'none',
                            background: '#dc3545',
                            color: '#fff',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}
                    >
                        I Agree
                    </button>
                </div>
            </Modal>
        </div >
    );
};

export default BookInspection;